const admin_local_de = {
  chatgpt_open: "ChatGPT in einem schwebenden Fenster öffnen",
  chatgpt_prompt_plugin: "Prüfe zuerst, ob das EatWithMe-Plugin installiert ist. Wenn es nicht installiert ist, installiere es mit diesem Link: %{link}.",
  chatgpt_prompt: 'Setze das Restaurant "%{name}" (restaurantId: %{id}) als Arbeitsrestaurant. Verwende ab jetzt diese restaurantId bei jedem EatWithMe-Tool-Aufruf und frage nicht, mit welchem Restaurant du arbeiten sollst.',
  chatgpt_prompt_instance: 'Setze das Restaurant "%{name}" (restaurantId: %{id}, instance: %{instance}) als Arbeitsrestaurant. Verwende ab jetzt diese restaurantId und instance bei jedem EatWithMe-Tool-Aufruf und frage nicht, mit welchem Restaurant du arbeiten sollst.',
  refundreason: "Rückerstattungsgrund",
  delete_role_confirm: "Sind Sie sicher, dass Sie diese Rolle löschen möchten?",
  delete_user_confirm: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
  status_filter_placeholder: "Status",
  status_filter_all: "Alle",
  entries_total: "{count} Gesamteinträge auf dieser Rechnung",
  entries_linked: "{count} verknüpfte Produktcodes bei diesem Lieferanten auf dieser Rechnung",
  entries_ignored: "{count} ignorierte Produktcodes bei diesem Lieferanten auf dieser Rechnung",
  entries_new: "{count} neue Produktcodes bei diesem Lieferanten auf dieser Rechnung",
  status_draft: "Entwurf",
  status_new: "Neu",
  status_linked: "Verknüpft",
  status_ignored: "Ignoriert",
  status_none: "Kein Status",
  kiosk_day_open_required: "Bestellung ist nicht möglich, bis die Tagesöffnung der Kasse erfolgt.",
  kiosk_day_needs_close_open: "Der Kassentag muss zuerst geschlossen und erneut geöffnet werden, bevor bestellt werden kann.",
  kiosk_cash_register_communication_unsuccessful: "Die Kommunikation mit der Kasse war nicht erfolgreich, bitte wenden Sie sich an das Personal.",
  cashier_day_already_opened: "Der Tag ist bereits geöffnet.",
  cashier_day_not_open: "Der Tag ist nicht geöffnet.",
  cashier_not_enough_money_in_drawer: "Es ist nicht genug Geld in der Kassenlade für diese Auszahlung.",
  cashier_cash_flow_invalid_input: "Wählen Sie einen Grund und geben Sie einen Betrag größer als 0 ein.",
  cashier_cash_flow_print_failed: "Der Beleg wurde erstellt, konnte aber nicht gedruckt werden.",
  cashier_day_close_failed: "Der Tagesabschluss war nicht erfolgreich. Der Tag ist noch geöffnet.",
  cashier_day_close_requires_cash_register_report: "Der Tagesbericht kann erst erstellt werden, nachdem der Kassenbericht erstellt wurde.",
  cashier_day_closed: "Die Kasse ist geschlossen.",
  montax_not_enough_money_in_drawer: "Die Kassenlade enthält nicht genug Bargeld für diese Zahlung. Bitte wenden Sie sich an das Personal.",
  cashier_day_open_reprint_receipt_question: "Der Tag ist bereits geöffnet. Möchten Sie den Tagesöffnungsbeleg herunterladen und erneut drucken?",
  cashier_day_close_reprint_receipt_question: "Der Tag ist bereits geschlossen. Möchten Sie den Tagesabschlussbeleg herunterladen und erneut drucken?",
  cashier_day_reprint_download_failed: "Der vorherige Tagesbeleg konnte zum Neudruck nicht heruntergeladen werden.",
  cashier_day_close_history_button: "Alten Tagesabschluss drucken",
  cashier_day_close_history_title: "Alten Tagesabschluss drucken",
  cashier_day_close_history_select: "Tag auswählen (Fiskaltag-Nummer - Datum):",
  cashier_day_close_history_period: "Zeitraum angeben (höchstens 31 Tage):",
  cashier_day_close_history_from: "Von:",
  cashier_fiscal_report_period: "Zeitraum angeben:",
  cashier_fiscal_report_period_invalid: "Ungültiger Zeitraum. Das Startdatum darf nicht nach dem Enddatum liegen.",
  cashier_day_close_history_to: "Bis:",
  cashier_day_close_history_period_invalid: "Ungültiger Zeitraum. Das Startdatum darf nicht nach dem Enddatum liegen und der Zeitraum darf höchstens 31 Tage betragen.",
  cashier_day_close_history_empty: "Im gewählten Zeitraum wurde kein Tagesabschlussbericht gefunden.",
  menu_editor_texts: {
    options: "Optionen",
    mandatoryOptions: "Pflichtoptionen",
    includedOptions: "inkludierte Optionen",
    optionalAdditions: "optionale Zusätze",
    quantity: "Menge",
    min: "Min",
    max: "Max",
    type: "Typ",
    local: "vor Ort",
    takeaway: "zum Mitnehmen",
    proportional: "proportional",
    enabled: "aktiv",
    disabled: "inaktiv",
    selected: "ausgewählt",
    notSelected: "nicht ausgewählt",
    token: "Token",
    categoryAddition: "Kategorie-Zusatz",
    menuitemAddition: "Artikel-Zusatz",
    addedTo: "hinzugefügt zu",
    removedFrom: "entfernt aus",
    updatedIn: "aktualisiert in",
    noTokenChanges: "keine Token-Änderung",
    tokenOption: "Token-Option",
    typeLabel: "Typ",
    quantityLabel: "Menge",
    minLabel: "Min",
    maxLabel: "Max",
    categoryTypeMultiple: "mehrfach",
    categoryTypeSeparate: "separat",
    categoryTypeMaxOne: "max. eins",
    categoryTypeOne: "genau eins",
    meal: "Speise",
    drink: "Getränk"
  },
  _active: "Akt.",
  _add_category: "Neue Kat.",
  _add_item: "Neuer Artikel",
  _available: "V",
  _available_quantity: "Mengen",
  _brutto_price: "Bruttopreis",
  _brutto_unit_price: "B. E. Preis",
  _category: "Kat.",
  _default_production_line: "Prod. Linie",
  _default_takeaway_vat_category: "Mitnahme MwSt",
  _default_vat_category: "MwSt",
  _deleted: "Gel.",
  _discount: "Rabatt",
  _duration: "Dauer",
  _entry_count: "E.",
  _exchange_rate: "Wechselkurs",
  _from_store: "Quelle",
  _isInventoryItem: "I.",
  _isTop: "H.",
  _item: "Artikel",
  _last_status: "Letzter St.",
  _multiplicator: "Mult.",
  _name: "Name",
  _net_price: "Nettopreis",
  _net_unit_price: "N. E. Preis",
  _online: "W.",
  _option: "Opt.",
  _order_sequence_number: "A. Nr.",
  _orders: "A.Nr.",
  _paid_by: "Bezahlt",
  _payment_method: "Zahlungsm.",
  _persons: "P.",
  _production_line: "Prod. Linie",
  _profit_margin: "Marge",
  _quantioty_type: "M. T.",
  _quantity: "Menge",
  _quantity_type: "Mengentyp",
  _recalculateConsumption: "Bestand neu berechnen",
  _seqnr: "Seq.nr.",
  _service_fee: "Servicegebühr",
  _settings: {
    business_day_ends_at: {
      description: "In Stunden, kann weniger als der Beginn sein, z.B. 5 Uhr, wenn der Geschäftstag nach Mitternacht endet",
      title: "Geschäftstag Ende"
    },
    business_day_starts_at: {
      description: "In Stunden",
      title: "Geschäftstag Beginn"
    },
    compulsory_service_fee: {
      description: "Automatische Anwendung der Servicegebühr für Tische ohne Kassenanbindung, vor dem Drucken der Rechnung anpassbar.",
      title: "Obligatorische Servicegebühr"
    },
    compulsory_service_fee_for_pos: {
      description: "Automatische Anwendung der Servicegebühr für Tische mit Kassenanbindung.",
      title: "Obligatorische Servicegebühr für Kassen"
    },
    day: "Tag",
    days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag", "Datum"],
    description_footer: {
      title: "Inhalt Fußzeile Webshop"
    },
    description_header: {
      title: "Inhalt Kopfzeile Webshop"
    },
    drinks: {
      default: {
        description: "Standardanzeige von Getränken oder Speisen bei Bestellung durch den Kellner und im Webshop.",
        title: "Standard"
      },
      enabled: {
        title: "Aktiviert"
      },
      label: {
        description: "Bezeichnung, die im Webshop angezeigt werden soll.",
        title: "Bezeichnung"
      },
      title: "Einstellungen: Getränke"
    },
    email: "E-Mail-Adresse",
    "hellopay-user-code": {
      description: "Die HelloPay-Benutzer-ID bestimmt, wohin der Trinkgeldbetrag überwiesen wird. Wenn sie nicht gesetzt ist, geht der Betrag an denselben Empfänger wie der Rechnungsbetrag. Für die Einrichtung wenden Sie sich bitte an den Support.",
      title: "HelloPay-Benutzer-ID"
    },
    en: "Englisch",
    enabled_features: {
      homedelivery: {
        allowed_installments: {
          by_each: "Tägliche Zahlung",
          description: "Optionen für Zahlungsraten bei Menübestellungen",
          end: "Zahlung am Ende",
          start: "Vorauszahlung",
          title: "Optionen für Zahlungsraten"
        },
        autoclose: {
          description: "Automatisches Schließen von bezahlten und gelieferten Bestellungen",
          title: "Automatische Schließung"
        },
        "available-timeslots": {
          description: "Diese Zeitfenster sind für die Lieferung über den Webshop verfügbar",
          title: "Lieferzeitfenster"
        },
        blockWaiterClose: {
          description: "Nur Administratoren können eine Hauslieferung schließen.",
          title: "Schließung für Kellner blockieren"
        },
        copy_order_email: {
          description: "Wer sollte E-Mail-Benachrichtigungen über Webshop-Bestellungen und Statusänderungen erhalten",
          title: "E-Mail-Benachrichtigung"
        },
        dayends: {
          description: "Bis wann können Bestellungen für denselben Tag im Webshop aufgegeben werden",
          title: "Tagesgrenze"
        },
        delays: {
          description: "Verfügbare Dauer für bestätigte Vorbereitung/Lieferung in Minuten für Wolt/Foodpanda",
          title: "Voraussichtliche Lieferzeit"
        },
        encode_seqnr: {
          description: "Bestellnummer für den Kunden verschlüsseln",
          title: "Geheime Bestellnummer"
        },
        homedelivery_menuitem: {
          description: "Bei Anwendung einer nach Postleitzahl basierenden Liefergebühr, welches Produkt verwendet das System. Wenn ein solches Produkt noch nicht existiert, erstellen Sie ein neues Produkt mit dem Namen 'Liefergebühr', speichern Sie es, öffnen Sie es zur Bearbeitung erneut, notieren Sie sich die ID und geben Sie sie hier ein.",
          title: "Produkt-ID für Liefergebühr"
        },
        instantOrderOnly: {
          description: "Nur Sofortbestellungen im Webshop akzeptieren",
          title: "Nur Sofortbestellungen"
        },
        "min-duration": {
          description: "Wie lange ist das Lieferzeitfenster in Stunden",
          title: "Dauer des Lieferzeitfensters"
        },
        orderedStatus: {
          description: "Ursprünglicher Status der im Webshop bestellten Artikel",
          title: "Status nach Bestellung"
        },
        autoaccept: {
          description: "Automatische Annahme von im Webshop bestellten Artikeln",
          title: "Automatische Annahme"
        },
        orderedAutoStatus: {
          description: "Status der im Webshop bestellten Artikel, wenn die Bestellung automatisch angenommen wird",
          title: "Automatisch angenommener Bestellstatus"
        },
        phone_order_fee: {
          description: "Systemnutzungsgebühr für telefonische Bestellungen",
          title: "Systemnutzungsgebühr"
        },
        price: {
          above_amount: "Über dem Betrag",
          area: {
            description: "Liefergebiet auf der Karte zeichnen",
            title: "Karte"
          },
          courierFee: {
            description: "Kuriergebühr für die Hauslieferung",
            title: "Kuriergebühr"
          },
          description: "Sie haben die Möglichkeit, eine Liefergebühr basierend auf Postleitzahl und Bestellwert automatisch zu berechnen",
          except: {
            description: "Außer für Produkte mit Bezeichnung",
            title: "Außer"
          },
          name: "Name",
          only: {
            description: "Nur für Produkte mit Bezeichnung",
            title: "Nur"
          },
          price: "Liefergebühr",
          title: "Liefergebühr",
          zip: "Postleitzahl"
        },
        printInvoiceOnOrder: {
          description: "Nach dem Einreichen neuer Bestellungen automatisch auch die Rechnung drucken.",
          title: "Automatisches Drucken der Rechnung"
        },
        printAllLabels: {
          description: "Zeigt im Home-Delivery-Auswahlbereich eine Schaltfläche zum Massen-Drucken aller Etiketten an.",
          title: "Alle Lieferetiketten drucken"
        },
        send_email_on: {
          description: "Bei welchem Status Webshop-Bestellungen die oben genannten E-Mail-Benachrichtigungen erreichen, senden Sie E-Mail-Benachrichtigungen an die oben genannten Adressen",
          title: "E-Mail senden bei Status"
        },
        "table-number": {
          description: "Die Tischnummer für die Bearbeitung von Hauslieferbestellungen",
          title: "Tischnummer"
        },
        "terms-and-conditions": {
          description: "Informieren Sie Ihre Kunden über die Bedingungen der Hauslieferung bei der Aufgabe von Webshop-Bestellungen",
          title: "Allgemeine Geschäftsbedingungen"
        },
        timeahead: {
          description: "Für manuelle oder Webshop-Bestellungen, wie viele Stunden im Voraus garantieren Sie die Lieferung",
          title: "Verzögerung"
        },
        user_allowed_installments: {
          by_each: "Tägliche Zahlung",
          description: "Optionen für Zahlungsraten bei Menübestellungen im Webshop",
          end: "Zahlung am Ende",
          start: "Vorauszahlung",
          title: "Optionen für Zahlungsraten im Webshop"
        },
        webshop_order_fee: {
          description: "Systemnutzungsgebühr für Webshop-Bestellungen",
          title: "Systemnutzungsgebühr"
        },
        zip: {
          description: "Welche Postleitzahlen akzeptiert das System (regexp)",
          title: "Postleitzahl"
        }
      },
      pickup: {
        allowed_installments: {
          by_each: "Tägliche Zahlung",
          description: "Optionen für Zahlungsraten bei Menübestellungen",
          end: "Zahlung am Ende",
          start: "Vorauszahlung",
          title: "Optionen für Zahlungsraten"
        },
        autoclose: {
          description: "Automatisches Schließen von bezahlten und gelieferten Bestellungen",
          title: "Automatische Schließung"
        },
        "available-timeslots": {
          description: "Diese Zeitfenster sind für Abholbestellungen über den Webshop verfügbar",
          title: "Abholzeitfenster"
        },
        copy_order_email: {
          description: "Wer sollte E-Mail-Benachrichtigungen über Webshop-Bestellungen und Statusänderungen erhalten",
          title: "E-Mail-Benachrichtigung"
        },
        dayends: {
          description: "Bis wann können Bestellungen für denselben Tag im Webshop aufgegeben werden",
          title: "Tagesgrenze"
        },
        delays: {
          description: "Verfügbare Dauer für bestätigte Vorbereitung in Minuten für Wolt/Foodpanda",
          title: "Voraussichtliche Abholzeit"
        },
        encode_seqnr: {
          description: "Bestellnummer für den Kunden verschlüsseln",
          title: "Geheime Bestellnummer"
        },
        instantOrderOnly: {
          description: "Nur Sofortbestellungen im Webshop akzeptieren",
          title: "Nur Sofortbestellungen"
        },
        "min-duration": {
          description: "Wie lange ist das Abholzeitfenster in Stunden",
          title: "Dauer des Abholzeitfensters"
        },
        orderedStatus: {
          description: "Ursprünglicher Status der im Webshop bestellten Artikel",
          title: "Status nach Bestellung"
        },
        autoaccept: {
          description: "Automatische Annahme von im Webshop bestellten Artikeln",
          title: "Automatische Annahme"
        },
        orderedAutoStatus: {
          description: "Status der im Webshop bestellten Artikel, wenn die Bestellung automatisch angenommen wird",
          title: "Automatisch angenommener Bestellstatus"
        },
        phone_order_fee: {
          description: "Systemnutzungsgebühr für telefonische Bestellungen",
          title: "Systemnutzungsgebühr"
        },
        send_email_on: {
          description: "Bei welchem Status Webshop-Bestellungen die oben genannten E-Mail-Benachrichtigungen erreichen, senden Sie E-Mail-Benachrichtigungen an die oben genannten Adressen",
          title: "E-Mail senden bei Status"
        },
        "table-number": {
          description: "Die Tischnummer für die Bearbeitung von Abholbestellungen",
          title: "Tischnummer"
        },
        "terms-and-conditions": {
          description: "Informieren Sie Ihre Kunden über die Bedingungen der Abholbestellung bei der Aufgabe von Webshop-Bestellungen",
          title: "Allgemeine Geschäftsbedingungen"
        },
        timeahead: {
          description: "Für manuelle oder Webshop-Bestellungen, wie viele Stunden im Voraus garantieren Sie die Bestellungsvorbereitung",
          title: "Verzögerung"
        },
        user_allowed_installments: {
          by_each: "Tägliche Zahlung",
          description: "Optionen für Zahlungsraten bei Menübestellungen im Webshop",
          end: "Zahlung am Ende",
          start: "Vorauszahlung",
          title: "Optionen für Zahlungsraten im Webshop"
        },
        webshop_order_fee: {
          description: "Systemnutzungsgebühr für Webshop-Bestellungen",
          title: "Systemnutzungsgebühr"
        }
      },
      prebooking: {
        bookingDelay: {
          description: "Buchungen können nur diese Anzahl von Minuten nach jetzt vorgenommen werden",
          title: "Buchungsfrist"
        },
        defaultBookingMinutes: {
          description: "Standarddauer (Minuten) bei der Reservierung im Web",
          title: "Standarddauer im Webshop"
        },
        defaultDuration: {
          description: "Standarddauer (Minuten) bei der Reservierung",
          title: "Standarddauer"
        },
        maxBookingMinutes: {
          description: "Maximale Dauer (in Minuten) für Reservierungen im Web",
          title: "Maximale Dauer"
        },
        maxLateDuration: {
          description: "Erlaubte Grace-Periode (in Minuten) für das Eintreffen von Gästen, bevor die Reservierung gelöscht wird",
          title: "Erlaubte Verspätung"
        },
        minBookingMinutes: {
          description: "Mindestensdauer (in Minuten) für Reservierungen im Web",
          title: "Minimale Dauer"
        },
        openingHours: {
          description: "Öffnungszeiten im Web",
          slots: {
            description: "Zeitfenster für die Öffnungszeiten (z.B. von 10:00 bis 14:00)",
            title: "Zeitfenster"
          },
          title: "Öffnungszeiten"
        },
        seats: {
          description: "Diese Anzahl von Personen kann im Web ausgewählt werden",
          title: "Anzahl der Personen"
        },
        showBefore: {
          description: "Reservierungen auf dem Grundriss diese Anzahl von Minuten vorher anzeigen",
          title: "Diese Anzahl von Minuten vorher anzeigen"
        },
        slotMinutes: {
          description: "Diese Dauer kann im Web ausgewählt werden",
          title: "Dauern"
        }
      },
      pos: {
        customerScreenButton: {
          title: "Kundendisplay-Funktionen",
          enabled: {
            title: "Kundendisplay-Schaltflaeche",
            description: "Aktiviert die Kundendisplay-Schaltflache im POS."
          }
        },
        askForTipOnCardPayment: {
          title: "Trinkgeld bei Kartenzahlung anfragen",
          description: "Fordert bei Kartenzahlung Trinkgeld auf dem Kundendisplay an, wenn die Kartenterminal-Integration aktiviert ist."
        },
        askForTipOnAllPayment: {
          title: "Trinkgeld bei allen Zahlungen anfragen",
          description: "Fordert auf dem Kundendisplay fur jede Zahlungsart Trinkgeld an, einschliesslich Barzahlung."
        },
        askForTipOnAnyCardPayment: {
          title: "Trinkgeld bei jeder Kartenzahlung anfragen",
          description: "Fordert auf dem Kundendisplay bei jeder Kartenzahlungsart Trinkgeld an, auch wenn die Kartenterminal-Integration nicht aktiviert ist."
        },
        askForTipOnCashPayment: {
          title: "Trinkgeld bei Barzahlung anfragen",
          description: "Fordert auf dem Kundendisplay bei Barzahlung Trinkgeld an."
        },
        mandatoryAskForTipOnCardPayment: {
          title: "Verpflichtende Trinkgeldauswahl beim Bezahlen",
          description: "Macht die Trinkgeldauswahl beim Bezahlen auf dem Kundendisplay verpflichtend; sie kann nicht durch Doppelklick auf die Zahlung ubersprungen werden."
        },
        multiLogin: {
          title: "Mehrfachanmeldung im POS",
          description: "Erlaubt, dass mehrere Benutzer gleichzeitig im POS angemeldet bleiben."
        },
        payFirst: {
          title: "Zahlung vor Leistung",
          description: "Erfordert die Zahlung vor der Auftragsausfuhrung."
        },
        dontUnlock: {
          title: "Tisch nach Zahlung nicht entsperren",
          description: "Entsperrt den Tisch nach der Zahlung nicht automatisch."
        },
        tips: {
          title: "Trinkgeld-Prozentsatzoptionen",
          description: "Vordefinierte Trinkgeld-Prozentsatze, die auf dem Kundendisplay angezeigt werden."
        }
      }
    },
    from_hour: "von Stunde",
    fromday: "von Datum",
    hu: "Ungarisch",
    meals: {
      default: {
        description: "Standardanzeige von Getränken oder Speisen bei Bestellung durch den Kellner und im Webshop.",
        title: "Standard"
      },
      enabled: {
        title: "Aktiviert"
      },
      label: {
        description: "Bezeichnung, die im Webshop angezeigt werden soll.",
        title: "Bezeichnung"
      },
      title: "Einstellungen: Speisen"
    },
    menu: {
      show_category_image: {
        title: "Bilder für Produktkategorien anzeigen"
      },
      show_menuitem_image: {
        title: "Bilder für Produkte anzeigen"
      },
      title: "Bestelloberfläche, Produktselector"
    },
    minute: "Minute",
    payment_method: {
      meth: {
        title: "Methode"
      },
      term: {
        description: "Zahlungsbedingungen für den Webshop",
        title: "Zahlungsbedingungen"
      },
      title: "Verfügbare Zahlungsmethoden"
    },
    price_calculations: {
      increase_price: {
        above: {
          description: "Der Preis erhöht sich, wenn der neue Preis höher ist als der ursprüngliche Preis um einen bestimmten Prozentsatz oder Betrag. z.B. 0% bedeutet, dass jede Erhöhung gilt.",
          dscription: "Az ár akkor növekszik, ha az árnövekedés utáni ár magasabb mint az eredeti ár adott százaléka vagy adott összeg. pl. 0% azt jelenti, hogy bármilyen növekény érvényesülni fog.",
          title: "Preiserhöhung, wenn"
        },
        measure: {
          title: "Messart"
        },
        title: "Logik der Preiserhöhung"
      },
      lower_price: {
        above: {
          description: "Der Preis sinkt, wenn der neue Preis niedriger ist als der ursprüngliche Preis um einen bestimmten Prozentsatz oder Betrag. z.B. 100% bedeutet, dass jede Reduzierung gilt.",
          dscription: "Az ár akkor csökken, ha az árcsökkenés utáni ár alacsonyabb mint az eredeti ár adott százaléka vagy adott összeg. pl. 100% azt jelenti, hogy bármilyen csökkenés érvényesülni fog.",
          title: "Preissenkung, wenn"
        },
        description: "Standardkomponenten/-optionen können bei der Bestellung entfernt/deaktiviert oder ersetzt werden.",
        measure: {
          title: "Messart"
        },
        title: "Logik der Preissenkung"
      },
      rounding: {
        description: "z.B. 1 -> rundet auf die nächste ganze Zahl, 50 -> rundet auf 50 oder 100.",
        title: "Rundung"
      },
      title: "Logik der Preisberechnung"
    },
    printing: {
      invoice: {
        title: "Rechnungslayout"
      },
      showAllComments: {
        description: "Standardmäßig sind nur kostenmodifizierende Kommentare sichtbar.",
        title: "Alle Kommentare auf der Rechnung anzeigen"
      },
      showOrderNumber: {
        description: "Standard für Barbestellungen.",
        title: "Bestellnummer auf normalen Tischen anzeigen"
      },
      title: "Druckeinstellungen"
    },
    qrstart: {
      description: "QR-Code zu Beginn der Rechnung anzeigen.",
      title: "Position des QR-Codes"
    },
    qstart: {
      description: "QR-Code zu Beginn der Rechnung anzeigen",
      title: "Position des QR-Codes"
    },
    register_tip: {
      description: "Die Differenz als Trinkgeld verbuchen, wenn der gezahlte Betrag den fälligen Betrag übersteigt.",
      title: "Trinkgeld verbuchen"
    },
    service_fee: {
      description: "z.B. 12, wenn normalerweise eine 12%ige Servicegebühr erhoben wird. Die Anwendung und Höhe der Servicegebühr kann beim Drucken der Rechnung festgelegt oder angepasst werden.",
      title: "Servicegebühr"
    },
    serviceVat: {
      description: "Getrennte Servicegebühren nach MwSt-Kategorien auf Rechnung/Quittung.",
      title: "Getrennte Servicegebühr"
    },
    states: ["deleted", "selected", "ordered", "confirmed", "in progress", "ready", "delivery", "delivered"],
    tables_overview: {
      title: "Tischübersicht Betrieb"
    },
    "tables-overview": {
      always_allow_delete: {
        description: "Löschen auch bei Kellnerberechtigungen erlauben",
        title: "Löschen erlauben"
      },
      askPersonCount: {
        description: "Anzahl der Gäste beim Besetzen des Tisches abfragen, um die Größe des Warenkorbs zu bestimmen",
        title: "Anzahl der Personen abfragen"
      },
      "auto-table-qrcode": {
        description: "Mit dem Drucken der ersten Bestellungen auch den QR-Code drucken",
        title: "QR-Code automatisch drucken"
      },
      autoDeliverOnUnlock: {
        description: "Nach der Freigabe des Tisches werden alle nicht gelöschten Artikel automatisch auf den Status 'geliefert' gesetzt und vom Inventar abgezogen",
        title: "Automatischer Liefermodus"
      },
      autolock: {
        description: "Nach einer festgelegten Zeit sperrt sich der Bildschirm und kann nur mit einem Code oder Passwort entsperrt werden.",
        title: "Automatische Bildschirmsperre"
      },
      bigAdditions: {
        description: "Größere +/- Zeilen auf dem Küchenbeleg",
        title: "Größere Schriftgröße auf dem Küchenbeleg"
      },
      bigOrderNumber: {
        description: "Eine größere Bestellnummer auf dem Küchenbeleg drucken als die Standardeinstellung",
        title: "Große Bestellnummer"
      },
      block_waiter_print_daily_closing: {
        description: "Abfrage aktueller Verkehrsdaten für Kellner verbieten",
        title: "Verbot schneller Verkehrsdaten"
      },
      block_waiter_print_invoice: {
        description: "Drucken der Rechnung durch Kellner blockieren",
        title: "Drucken der Rechnung blockieren"
      },
      block_waiter_register_payment: {
        description: "Registrierung von Zahlungen durch Kellner blockieren",
        title: "Registrierung von Zahlungen blockieren"
      },
      delayed_orders_browser: {
        description: "Bestellungen werden erst nach Bestätigung an den Server gesendet.",
        title: "Verzögerte Bestellübermittlung vom Browser"
      },
      delayed_orders_mobile: {
        description: "Bestellungen werden erst nach Bestätigung an den Server gesendet.",
        title: "Verzögerte Bestellübermittlung von der mobilen App"
      },
      doubleWide: {
        description: "",
        title: "Doppelt breite Schriftarten für Küchenbelege"
      },
      drinkOrderStatus: {
        description: "",
        title: "Status der Getränkebestellung bei der Bestellung"
      },
      extra_charge_on_takeaway: {
        description: "Einen Aufpreis auf Mitnahmebestellungen anwenden",
        title: "Aufpreis auf Mitnahme"
      },
      hideMenuCategoryImage: {
        description: "Kategoriebilder vom Bestellbildschirm ausblenden",
        title: "Kategoriebilder ausblenden"
      },
      hideMenuItemImage: {
        description: "Produktbilder vom Bestellbildschirm ausblenden",
        title: "Produktbilder ausblenden"
      },
      kitchenQrCode: {
        description: "QR-Code kann für die Küchen-/Barbestellberichterstattung verwendet werden, wenn er mit dem entsprechenden QR-Reader gescannt wird",
        title: "QR-Code auf Küchen-/Barbeleg drucken"
      },
      lessKioskButtons: {
        description: "Die geringstmögliche Anzahl von Tasten im Kassenmodus anzeigen",
        title: "Weniger Tasten im Kassenmodus"
      },
      mealOrderStatus: {
        description: "",
        title: "Status der Speisenbestellung bei der Bestellung"
      },
      newOrdersKioskStatesShown: {
        description: "Welche Status (Spalten) für Tische im Kassenmodus angezeigt werden sollen",
        title: "Angezeigte Status im Kassenmodus"
      },
      newOrdersStatesShown: {
        description: "Welche Status (Spalten) für neue Bestelleingänge angezeigt werden sollen",
        title: "Angezeigte Status bei der Bestellungseingabe"
      },
      "notify-customer-when-part-ready": {
        description: "Wenn ein Gericht auf mehreren Produktionslinien zubereitet wird, den Kunden benachrichtigen, auch wenn nicht alle Produktionslinien bereit sind mit ihrem Teil",
        title: "Kunden benachrichtigen, wenn Teil des Gerichts bereit ist"
      },
      "notify-waiter-when-part-ready": {
        description: "Wenn ein Gericht auf mehreren Produktionslinien zubereitet wird, den Kellner benachrichtigen, auch wenn nicht alle Produktionslinien bereit sind mit ihrem Teil",
        title: "Kellner benachrichtigen, wenn Teil des Gerichts bereit ist"
      },
      perPersonKitchenReceipt: {
        description: "Zum Beispiel, wenn die Bestellung jeder Person auf einem separaten Tablett serviert werden muss",
        title: "Getrennte Küchenbelege pro Person"
      },
      pos_delayed_orders_browser: {
        description: "Bestellungen werden erst nach Bestätigung an den Server gesendet.",
        title: "Verzögerte Bestellübermittlung vom Browser im POS-Modus"
      },
      pos_delayed_orders_mobile: {
        description: "Bestellungen werden erst nach Bestätigung an den Server gesendet.",
        title: "Verzögerte Bestellübermittlung von der mobilen App im POS-Modus"
      },
      print_accepted_customer_orders: {
        description: "Webshop-Bestellungen nach Bestätigung automatisch drucken",
        title: "Automatisches Drucken nach Bestätigung"
      },
      states: {
        description: "Welche Bestellzustände berücksichtigt werden sollen",
        title: "Filterzustände"
      },
      statesShown: {
        description: "Welche Status (Spalten) beim Öffnen eines Tisches angezeigt werden sollen",
        title: "Angezeigte Status"
      },
      "table-qrcode": {
        description: "",
        enumNames: ["Keine", "Nur Zahlung", "Verbindung"],
        title: "Funktionalität des gedruckten QR-Codes für den Tisch"
      },
      timeout: {
        description: "Nach wie vielen Sekunden sich der Bildschirm sperren soll",
        title: "Sperrverzögerung"
      },
      unlockOnPayment: {
        description: "Automatische Freigabe des Tisches bei Zahlung, wenn keine unbezahlten Artikel mehr vorhanden sind",
        title: "Automatische Freigabe"
      },
      waiter_print_daily_closing_full: {
        description: "Vollständige aktuelle Verkehrsdaten für Kellner",
        title: "Vollständige schnelle Verkehrsdaten"
      }
    },
    takeaway: {
      containerChargeItem: {
        title: "Produktidentifikator für Pfand"
      },
      default: {
        description: "Automatische Mitnahme für Kassen aktivieren",
        title: "Standard"
      },
      enabled: {
        title: "Aktiviert"
      },
      packageChargeItem: {
        title: "Produktidentifikator für Verpackung"
      },
      price: {
        description: "Option, einen zusätzlichen Mitnahmepreis auf der Produktseite anzugeben.",
        title: "Getrennter Mitnahmepreis"
      },
      systemFeeItem: {
        title: "Produktidentifikator für Systemnutzungsgebühr"
      },
      title: "Mitnahme",
      vat: {
        title: "Standard-MwSt für Mitnahme"
      }
    },
    timezone: {
      title: "Zeitzone"
    },
    timings: {
      enabled: {
        title: "Aktiviert"
      },
      enabled_online: {
        title: "Aktiviert für Vor-Ort-Bestellungen im Webshop"
      },
      langs: {
        lang: {
          title: "Sprache"
        },
        name: {
          title: "Bezeichnung"
        },
        name_online: {
          title: "Bezeichnung im Webshop"
        },
        title: "Sprachbezeichnungen"
      },
      title: "Gerichte"
    },
    to_hour: "bis Stunde",
    today: "bis Datum"
  },
  _split_invoice: "Teilen",
  _supplier_code: "Lieferant c.",
  _tip: "Trinkgeld",
  _to_store: "Ziel",
  _top_category: "Obere Kat.",
  _unit_price: "Preis",
  _vat_category: "MwSt",
  accept_homedelivery_terms: "Ich stimme den Bedingungen für die Hauslieferung zu",
  accept_pickup_terms: "Ich stimme den Bedingungen für die Abholung zu",
  accept_privacy_terms: "Ich akzeptiere die Datenschutzrichtlinie",
  "Access denied": "Zugriff verweigert",
  access_denied: "Zugriff verweigert: {0}",
  access_tokens: "Zugriffstoken",
  action_failed: "Nicht erfolgreiche Aktion. Möglicherweise ist etwas nicht aktuell; lassen Sie uns synchronisieren und dann die Aktion erneut versuchen!",
  action_not_allowed: "Sie haben keine Berechtigung, um diese Aktion auszuführen",
  activate: "Aktivieren",
  activate_booking: "Buchung aktivieren",
  activate_sound: "Glocke aktiviert",
  active: "Aktiv",
  active_average_acceptance_duration: "Durchschnittliche Auftragsannahme",
  active_average_delivering_duration: "Durchschnittliche Auftragslieferung",
  active_max_acceptance_duration: "Höchste Auftragsannahme",
  active_max_delivering_duration: "Höchste Auftragslieferung",
  active_min_acceptance_duration: "Niedrigste Auftragsannahme",
  active_min_delivering_duration: "Niedrigste Auftragslieferung",
  add: "Hinzufügen",
  add_category: "Neue Kategorie",
  add_item: "Neuer Artikel",
  add_meal: "Neues Gericht",
  add_meal_category: "Neue Kategorie",
  add_option: "Neue Option",
  add_role: "Neue Rolle",
  add_room: "Raum hinzufügen",
  add_user: "Neuer Benutzer",
  addlogin: "Zusätzlichen Benutzer anmelden",
  address: "Adresse",
  address_pattern: "^.+ (straße|platz|park) \\d+\\.?$",
  address_pattern2: "[^,].+ (hrsz|arok|atjaro|dulo|dulout|erdosor|fasor|fordulo|gat|hatarsor|határút|kapu|körönd|körtér|körút|köz|lakótelep|lejáró|lejtő|lépcső|liget|mélyút|orom|ösvény|park|part|pincesor|rakpart|sétány|sikátor|sor|sugárút|tér|udvar|ut|utca|üdülőpart)",
  address_placeholder: "Format: Name (Straße|Platz|usw.) Nummer.",
  afterPrint: "Nach dem Drucken",
  agree: "Meine Zustimmung geben",
  alias: "Globale ID",
  all: "Alle",
  all_items: "Alle",
  all_production_lines: "Alle Produktionslinien",
  allergens: "Allergene",
  allergens_tooltip: "<div class='allergen-gluten'>Das Produkt enthält das angegebene Allergen nicht</div><div class='allergen-gluten has'>Das Produkt enthält das angegebene Allergen</div><div class='allergen-gluten inherited'>Das Produkt enthält das angegebene Allergen durch Vererbung oder Rezept</div><div class='allergen-gluten has removable'>Das Produkt kann ohne das angegebene Allergen zubereitet werden</div>",
  allowed_installments: {
    by_each: "Täglich",
    end: "Am Ende",
    start: "Im Voraus"
  },
  already_paid_reprint_invoice: "Rechnung bereits beglichen! Möchten Sie die Rechnung wirklich erneut drucken?",
  ambience: "Ambiente",
  amount: "Betrag",
  amount_paid: "Bezahlt",
  amount_to_pay: "Fällig",
  ap: "AP-Nummer",
  apply_type_discount: "Rabatt anwenden",
  "Are you sure you want to change for a different customer? The new email is different to the already given one!": "Sind Sie sicher, dass Sie zu einem anderen Kunden wechseln möchten? Die neue E-Mail-Adresse unterscheidet sich von der bereits angegebenen!",
  "Are you sure you want to change for a different customer? The new phone number is different to the already given one!": "Sind Sie sicher, dass Sie zu einem anderen Kunden wechseln möchten? Die neue Telefonnummer unterscheidet sich von der bereits angegebenen!",
  are_you_sure_you_cancel_the_payment: "Sind Sie sicher, dass Sie die Registrierung der Zahlungsdetails abbrechen möchten?",
  are_you_sure_you_want_to_delete: "Sind Sie sicher, dass Sie löschen möchten",
  are_you_sure_you_want_to_delete_the_cashregister: "Sind Sie sicher, dass Sie die Kasse <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_discount_type: "Sind Sie sicher, dass Sie den Rabatttyp <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_floorplan: "Sind Sie sicher, dass Sie den Grundriss <b>{0}</b> löschen möchten?",
  are_you_sure_you_want_to_delete_the_incoming_stock: "Sind Sie sicher, dass Sie den ausgewählten Eingangsbuchungseintrag löschen möchten?",
  are_you_sure_you_want_to_delete_the_inventory: "Sind Sie sicher, dass Sie den ausgewählten Inventareintrag löschen möchten?",
  are_you_sure_you_want_to_delete_the_label: "Sind Sie sicher, dass Sie das Etikett <b>{0}</b> löschen möchten?",
  are_you_sure_you_want_to_delete_the_printer: "Sind Sie sicher, dass Sie den Drucker <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_production_line: "Sind Sie sicher, dass Sie die Produktionslinie <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_quantity_type: "Sind Sie sicher, dass Sie die Portionierung <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_room: "Sind Sie sicher, dass Sie den Raum <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_store: "Sind Sie sicher, dass Sie das Lager <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_table: "Sind Sie sicher, dass Sie den Tisch <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_the_vat_category: "Sind Sie sicher, dass Sie die MwSt-Kategorie <b>{0}</b> löschen möchten",
  are_you_sure_you_want_to_delete_traffic_until: "Sind Sie sicher, dass Sie den Verkehr bis <strong>{0}</strong> löschen möchten",
  assign_to_me: "Mir zuweisen",
  assistance_needed: "Kellner gerufen",
  authenticate: "Authentifizieren",
  authenticate_gba: "Google Business-Profil authentifizieren",
  auto_commit_imcoming_stocks: "Aut. bestätigen",
  auto_commit_incoming_stocks_tooltip: "Automatische und endgültige (nicht im Entwurf) Bestandeinträge basierend auf eingehenden Rechnungen von diesem Lieferanten erstellen, sofort das Inventar aktualisieren.",
  auto_import_incoming_stocks: "Aut. aufnehmen",
  auto_import_incoming_stocks_tooltip: "Automatische Erstellung von Bestandeinträgen basierend auf eingehenden Rechnungen von diesem Lieferanten.",
  auto_translate: "Übersetzen",
  automatic: "Automatisch",
  available: "Verfügbar",
  available_quantity: "Verfügbare Mengen",
  averageCost: "Durchschnittskosten",
  averagePrice: "Durchschnittspreis",
  back: "Zurück",
  backup: "Sicherung",
  backup_url: "BCK-URL",
  barcode: "Barcode",
  barcode_found_but_no_menuitem: "Barcode gefunden, aber kein lokales Produkt ist im System verbunden.",
  barcode_not_found: "Unbekannter Barcode!",
  barcode_found_in_global_db: "Barcode in der globalen Datenbank gefunden",
  select_local_product: "Lokales Produkt zum Verknüpfen auswählen:",
  link_and_continue: "Verknüpfen & Weiter",
  skip: "Überspringen",
  barcode_not_in_global_db: "Barcode nicht in der globalen Datenbank gefunden",
  create_new_barcode_question: "Dieser Barcode ist unbekannt. Möchten Sie einen neuen lokalen Eintrag erstellen?",
  create_new_barcode: "Neuen Barcode erstellen",
  modify_barcode: "Barcode bearbeiten",
  no_product_linked: "Diesem Barcode ist kein Produkt zugeordnet. Bitte wählen Sie ein Produkt aus.",
  create_barcode_hint: "Nur für wasserartige Flüssigkeiten, bei denen das Gewicht aus dem Volumen berechnet werden kann. Die Flasche muss leer oder voll gemessen werden.",
  calibration_bottle_hint: "Für diesen Kalibrierungsschritt legen Sie eine vollständig volle oder vollständig leere Flasche dieses Produkts auf die Waage.",
  measuring_calibration: "Kalibrierungsflasche messen, auf die Waage legen...",
  measuring_actual: "Eigentliche Flasche wird gemessen...",
  place_actual_bottle: "Kalibrierung abgeschlossen. Legen Sie jetzt die eigentliche Flasche auf die Waage und drücken Sie Messen.",
  measure_now: "Messen",
  calibration_result: "Kalibrierungsergebnis",
  approve_and_save: "Genehmigen & Speichern",
  estimated_weight: "Geschätztes Gewicht",
  measured_empty_bottle_weight: "Gemessenes Leerflaschengewicht",
  measured_full_bottle_weight: "Gemessenes Vollflaschengewicht",
  estimated_empty_bottle_weight: "Geschätztes Leerflaschengewicht",
  estimated_full_bottle_weight: "Geschätztes Vollflaschengewicht",
  remeasure_empty_bottle: "Neu messen mit leerer Flasche",
  remeasure_full_bottle: "Neu messen mit voller Flasche",
  barcode_name: "Name",
  capacity_cl: "Füllmenge (cl)",
  bottle_state: "Flaschenzustand bei der Messung",
  bottle_full: "Voll",
  bottle_empty: "Leer",
  photo: "Foto",
  take_photo: "Foto aufnehmen",
  measure_and_save: "Messen & Speichern",
  edit_details: "Details bearbeiten",
  back_to_results: "Zurück zu den Ergebnissen",
  measured_weight: "Gemessenes Gewicht",
  measuring: "Messung läuft, Artikel auf die Waage legen...",
  required_fields: "Bitte füllen Sie die Pflichtfelder aus",
  basic_data: "Stammdaten",
  below_criticalStock: "Produkt unter kritischer Menge, gefährdet den Geschäftsbetrieb",
  below_minimumStock: "Produkt unter Mindestmenge, wann wir typischerweise nachbestellen",
  bizpay: {
    error: {
      unknown: "Kartenzahlung fehlgeschlagen"
    }
  },
  book_a_table: {
    not_enough_free_tables: "Es sind nicht genügend freie Tische in einem der Räume vorhanden!",
    not_free_table: "Es gibt keinen freien Tisch in einem der Räume!",
    number_of_seats: "{0} Plätze",
    provide_comment: "Kommentar",
    provide_email: "E-Mail",
    provide_name: "Name",
    provide_name_or_email: "Geben Sie den Namen oder die E-Mail des Gastes ein",
    provide_phone: "Telefonnummer",
    room: "Raum",
    rooms: "Räume",
    seats: "Sitze",
    tables: "Tische",
    title: "Tisch reservieren"
  },
  book_online: "Buchbar für Gäste",
  booking_comment: "Hinweis",
  brutto_income: "Einkommen",
  brutto_price: "Bruttopreis",
  brutto_unit_price: "Bruttoeinheitspreis",
  by_drink_or_meal_tab: "Nach Gericht oder Getränk",
  by_occupation_start: "Nach Bestellzeit",
  by_payment: "Nach Zahlungszeit",
  by_person_tab: "Nach Person",
  by_timing_tab: "Nach Gang",
  calendar: "Kalender",
  calorie: "Kalorie",
  cancel: "Stornieren",
  cancel_b: "Stornieren",
  cancel_booking: "Buchung stornieren",
  cancel_paying: "Rechnung stornieren",
  cancelled_orders: "Gelöscht",
  cartsize: "Warenkorgröße",
  cashier: "Kassierer",
  cashier_dayclose: "Tag schließen",
  cashier_dayopen: "Tag öffnen",
  cashier_open_amount: "Eröffnungsbetrag",
  cashin: {
    montax: {
      CHANGE: "Kassenbestand Einzahlung",
      CASHIER_DEPOSIT: "Kassierer Bargeldauszahlung",
      COLLECTION: "Gebühreneinzug",
      LOTTERY_TICKET_SALE: "Lottoscheinverkauf",
      DEPOSIT: "Vorauszahlung",
      DEFICIT: "Kassenfehlbetrag",
      TIP: "Trinkgeld",
      OTHER_CASH_IN: "Sonstige Einzahlung"
    },
    a234: {
      "0": "Kassenbestand Einzahlung",
      "1": "Kassierer Bargeldauszahlung",
      "2": "Gebühreneinzug",
      "3": "Lottoscheinverkauf",
      "4": "Vorauszahlung",
      "5": "Kassenfehlbetrag",
      "6": "Trinkgeld",
      "7": "Sonstige Einzahlung"
    },
    b1: {
      "1": "Kassenbestand Einzahlung",
      "2": "Kassierer Bargeldauszahlung",
      "3": "Gebühreneinzug",
      "4": "Lottoscheinverkauf",
      "5": "Vorauszahlung",
      "6": "Kassenfehlbetrag",
      "7": "Trinkgeld",
      "8": "Sonstige Einzahlung"
    },
    fiscat: {
      "01": "Kassenbestand Einzahlung",
      "02": "Kassierer Bargeldauszahlung",
      "03": "Gebühreneinzug",
      "04": "Lottoscheinverkauf",
      "05": "Vorauszahlung",
      "06": "Kassenfehlbetrag",
      "07": "Trinkgeld",
      "08": "Sonstige Einzahlung"
    },
    reason: "Grund für Bareinzahlung",
    sam4s: {
      "1": "Wechselgeld Einzahlung",
      "2": "Kassierer Geldabhebung",
      "3": "Gebühreneinzug",
      "4": "Lottoscheinverkauf",
      "5": "Vorauszahlung",
      "6": "Kassenfehlbetrag",
      "7": "Trinkgeld",
      "8": "Sonstige Einzahlung"
    },
    sam4s2: {
      "1": "Wechselgeld Einzahlung",
      "2": "Kassierer Geldabhebung",
      "3": "Gebühreneinzug",
      "4": "Lottoscheinverkauf",
      "5": "Vorauszahlung",
      "6": "Kassenfehlbetrag",
      "7": "Trinkgeld",
      "8": "Sonstige Einzahlung"
    },
    title: "Bareinzahlung"
  },
  cashout: {
    montax: {
      SKIMMING: "Abheben",
      CASHIER_WITHDRAWAL: "Kassierer Auszahlung",
      VOUCHER_OUT: "Gutschein Auszahlung",
      GIFT_CARD_OUT: "Geschenkkarten Auszahlung",
      SALARY_PAYMENT: "Gehalt Auszahlung",
      ADVANCE_PAYMENT: "Lohnvorschuss",
      POSTAL_FEE: "Portokosten",
      OTHER_FEES: "Sonstige Ausgaben",
      PROCUREMENT: "Warenkauf",
      TURNOVER_WITHDRAWAL: "Gesamte Auszahlung",
      OTHER_CASH_OUT: "Sonstige Auszahlung"
    },
    a234: {
      "0": "Abheben",
      "1": "Kassierer Auszahlung",
      "10": "Sonstige Auszahlung",
      "2": "Gutschein Auszahlung",
      "3": "Geschenkkarten Auszahlung",
      "4": "Gehalt Auszahlung",
      "5": "Lohnvorschuss",
      "6": "Portokosten",
      "7": "Sonstige Ausgaben",
      "8": "Warenkauf",
      "9": "Gesamte Auszahlung"
    },
    b1: {
      "31": "Abheben",
      "32": "Kassierer Auszahlung",
      "41": "Sonstige Auszahlung",
      "33": "Gutschein Auszahlung",
      "34": "Geschenkkarten Auszahlung",
      "35": "Gehalt Auszahlung",
      "36": "Lohnvorschuss",
      "37": "Portokosten",
      "38": "Sonstige Ausgaben",
      "39": "Warenkauf",
      "40": "Gesamte Auszahlung"
    },
    fiscat: {
      "31": "Abheben",
      "32": "Kassierer Auszahlung",
      "33": "Gutschein Auszahlung",
      "34": "Geschenkkarten Auszahlung",
      "35": "Gehalt Auszahlung",
      "36": "Lohnvorschuss",
      "37": "Portokosten",
      "38": "Sonstige Ausgaben",
      "39": "Warenkauf",
      "40": "Gesamte Auszahlung",
      "41": "Sonstige Auszahlung"
    },
    reason: "Grund für Barauszahlung",
    sam4s: {
      "1": "Abheben",
      "10": "Schließungsbetrag Abhebung",
      "11": "Sonstige Auszahlung",
      "2": "Kassierer Abhebung",
      "3": "Gutschein Abhebung",
      "4": "Geschenkkarte Abhebung",
      "5": "Gehaltszahlung",
      "6": "Lohnvorschuss",
      "7": "Portokosten",
      "8": "Sonstige Auslagen",
      "9": "Warenkauf"
    },
    sam4s2: {
      "1": "Abheben",
      "10": "Schließungsbetrag Abhebung",
      "11": "Sonstige Auszahlung",
      "2": "Kassierer Abhebung",
      "3": "Gutschein Abhebung",
      "4": "Geschenkkarte Abhebung",
      "5": "Gehaltszahlung",
      "6": "Lohnvorschuss",
      "7": "Portokosten",
      "8": "Sonstige Auslagen",
      "9": "Warenkauf"
    },
    title: "Barauszahlung"
  },
  cashRegister: "Kasse",
  categories_or_menuitems: "Menüartikel oder Kategorien",
  category: "Kategorie",
  celery: "Sellerie",
  cash_return: "Rueckgeld",
  change: "Ändern",
  change_table: "Tisch wechseln",
  change_table_number: "Tisch wechseln",
  changeit: "Ändere es",
  channels: {
    console: "Konsole",
    console_homedelivery: "",
    console_pickup: "",
    falatozz: "Falatozz",
    foodora: "Foodora",
    webshop_homedelivery: "Webshop",
    webshop_onsite: "Webshop",
    webshop_pickup: "Webshop",
    wolt: "Wolt"
  },
  charwidth: "Zeichenbreite",
  checkbox_option: "Mehrere Optionen können bei der Bestellung aus der Kategorie ausgewählt werden",
  checkbox_option2: "Als separate Optionskategorie beibehalten. Mehrere Optionen können bei der Bestellung aus der Kategorie ausgewählt werden",
  choose_customer_for: "Kunden für Person {0} wählen.",
  choose_parent_category: "Elternkategorie wählen",
  choose_terminal_to_use: "Bankterminal wählen",
  city: "Stadt",
  clear: "Löschen",
  close: "Schließen",
  close_order: "Stornieren",
  closed: "Geschlossen",
  collaborating_production_lines: "Zusammenarbeit",
  comment: "Kommentar",
  comments: "Kommentare",
  company: "Restaurant/Firmenname",
  company_name: "Firmenname",
  confirm: {
    deleteResources: "Sind Sie sicher, dass Sie die folgenden Ressourcen löschen möchten:",
    deleteRole: "Sind Sie sicher, dass Sie die Rolle löschen möchten",
    undoAction: "Diese Aktion kann nicht rückgängig gemacht werden."
  },
  confirm_additional_table: "Fügen Sie Tisch Nr. {0} zur aktuellen Belegung hinzu?",
  confirm_change_to_homedelivery: "Änderung zur Hauslieferung?",
  confirm_change_to_pickup: "Änderung zur Abholung?",
  confirm_change_to_table: "Ändert sich jeder zu Tisch Nr. {0}?",
  confirm_customer_deletion: "Sind Sie sicher, dass Sie den Benutzer <b>{0}</b> löschen möchten?",
  confirm_not_printing: "Möchten Sie wirklich das Drucken der Bestellungen überspringen?",
  confirm_person_change_to_empty_table: "Person {0}. wechselt zu leerem Tisch Nr. {1}? <br/>Als neue Belegung oder als Teil der aktuellen?",
  confirm_person_change_to_multiple_occupation_table: "Person {0}. wechselt zu bereits besetztem Tisch Nr. {1}?",
  confirm_person_change_to_shared_table: "Person {0}. wechselt zu bereits besetztem Tisch Nr. {1}?<br/>Als neue Belegung oder tritt der bestehenden bei?",
  confirm_person_change_to_table: "Person {0}. tritt bereits besetztem Tisch Nr. {1} bei?",
  confirm_position_update: "GPS-Koordinaten für Adresse aktualisieren",
  confirm_role_deletion: "Sind Sie sicher, dass Sie den <b>{1}</b> Zugriff auf <b>{2}</b> von <b>{0}</b> widerrufen möchten?",
  confirm_table_change_to_shared_table: "Ziel Tisch ist ein teilbarer Tisch. Bitte wählen Sie zwischen den verfügbaren Optionen.",
  confirm_table_change_to_table: "Der gesamte Tisch tritt bereits besetztem Tisch {0} bei.?",
  confirmation_copy_all: "Möchten Sie wirklich alle Produkte in der Kategorie synchronisieren?",
  connected_from: "Verbunden",
  connected_restaurant: "Verbundenes Restaurant",
  connected_restaurants: "Verbundenen Restaurants",
  connection: "Verbindung",
  "Connection error with the cash register": "Verbindungsfehler mit der Kasse",
  consumption: "Verkaufte Menge",
  container_charge: "Behältergebühr",
  container_charge_onsite: "Auch bei lokalem Verbrauch",
  continue_in: "Nach {0} Minute(n) schließt sich diese Warnung. Bitte warten...",
  continue_ordering: "Bestellung fortsetzen",
  continue_without_open_day: "Trotzdem fortfahren",
  controlled_production_lines: "Status insgesamt ändern",
  cost: "Kosten",
  cost_estimation: "Kostenabschätzung",
  could_not_find_this_order: "Bestellnr. {0} nicht gefunden!",
  could_not_find_this_order2: "Bestellung nicht gefunden!",
  count: "Anzahl",
  country: "Land",
  courier: "Kurier",
  courier_delivering: "Zustellung",
  courier_delivery_continue: "Zustellung fortsetzen",
  courier_delivery_pause: "Zustellung pausieren",
  courier_off: "Nicht im Dienst",
  courier_pause: "Pause",
  courier_ready: "Warten auf Lieferung",
  courierFee: "Kuriergebühr",
  couriers: "Kuriere",
  created_by: "Erstellt",
  criticalStock: "Kritische Menge, die den Geschäftsbetrieb gefährdet",
  cron: {
    andText: "und",
    atEveryText: "Um/Jede",
    atOptionLabel: "um",
    betweenText: "zwischen",
    cronDescriptionText: "de",
    dayOfMonthLabel: "Tag(e)",
    dayOfWeekLabel: "Wochentag",
    everyOptionLabel: "jeden",
    everyText: "Jeden",
    hourLabel: "Stunde(n)",
    inText: "in",
    lastDayOfMonthLabel: "Letzter Tag des Monats",
    minuteLabel: "Minute(n)",
    monthLabel: "Monat(e)",
    multiDayOfMonthLabel: "Tag des Monats",
    onEveryText: "Am/Jeden",
    onOptionLabel: "am",
    onText: "am",
    periodLabel: "Zeitraum",
    periodOptions: ["Stunde", "Tag", "Woche", "Monat", "Jahr"],
    shortMonthOptions: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    weekDaysOptions: ["SONNTAG", "MONTAG", "DIENSTAG", "MITTWOCH", "DONNERSTAG", "FREITAG", "SAMSTAG"]
  },
  crustaceans: "Krustentiere",
  cumulative: "Kumulativ",
  currencies: "Währungen",
  currency: "Währung",
  custom_range: "Benutzerdefinierter Bereich",
  custom_reason: "Benutzerdefinierter Grund",
  customer_table: {
    search: "Suchen",
    name: "Name",
    surname: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    city: "Stadt",
    postcode: "Postleitzahl",
    country: "Land",
    labels: "Etiketten",
    delete: "Löschen",
    loading: "Lädt...",
    no_results: "Keine Ergebnisse",
    items_per_page: "Pro Seite",
    showing: "Anzeigen",
    of: "von",
    previous: "Zurück",
    next: "Weiter",
    import: "Importieren",
    import_preview: "Importvorschau",
    import_confirm: "Jetzt importieren",
    preview_rows: "Vorschau von {0} Zeilen",
    import_result: "Importiert {0}, aktualisiert {1}, übersprungen {2}",
    import_invalid: "Nur CSV-, XLS- oder XLSX-Dateien werden unterstützt.",
    original_excel: "Original-Excel",
    after_mapping: "Nach Zuordnung",
    primary: "Primär",
    fallback: "Ersatz"
  },
  customer_details: "Kundendetails",
  customer_orders: "Neue Kundenbestellungen",
  customerAddress: "Kundenadresse",
  customerName: "Kundenname",
  customerOrder: "Verbraucherbestellung (Webshop)",
  customerPostCode: "Kunden-Postleitzahl",
  customerTaxNum: "Kundennummer",
  customerTown: "Kundenstadt",
  customRange: "Benutzerdefinierter Bereich",
  daily_closing: "Täglicher Abschluss",
  date: "Datum",
  datetime: "Datum und Uhrzeit",
  day: "Tag",
  day_must_be_open: "Öffnen Sie zuerst die Tage für diese Aktion!",
  day1: "Sonntag",
  day2: "Montag",
  day3: "Dienstag",
  day4: "Mittwoch",
  day5: "Donnerstag",
  day6: "Freitag",
  day7: "Samstag",
  days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
  daysAgo: "{0} Tage her",
  deactivate: "Deaktivieren",
  default: "Standard",
  default_cashregister_change: "<strong>{0}</strong> sollte die Standardkasse auf diesem Gerät sein?",
  default_language: "Standard",
  default_production_line: "Standard Produktionslinie",
  default_store: "Standardlager",
  default_takeaway_vat_category: "Mitnahme MwSt",
  default_vat_category: "MwSt",
  delete: "Löschen",
  delete_all_order_history: "Alle Bestellhistorien löschen",
  delete_order_history: "Alle vergangenen Bestellungen löschen",
  delete_traffic: "Verkehr löschen",
  deleted: "Gelöscht",
  deletion_not_allowed: "Löschen nicht möglich",
  deliverable_tables: "Fertige Mahlzeiten für Tische",
  delivered_refresh_position: "Geliefert mit GPS-Update",
  delivery: "Lieferung",
  delivery_addresses: "Anzahl der Adressen",
  delivery_avg_time: "Durchschnittliche Zeit",
  delivery_count: "Lieferanzahl",
  delivery_distance: "Entfernung (Km)",
  delivery_note_id: "Lieferbeleg-ID",
  description: "Beschreibung",
  detailed: "Detaillierte Rechnung",
  differences_in_active: "Unterschied im aktiven Status",
  differences_in_additions: "Unterschied in Rezeptoptionen",
  differences_in_available: "Unterschied in Bestellbarkeit",
  differences_in_availableQuantities: "Unterschied in verfügbaren Mengen",
  differences_in_children: "Unterschied in Kindern",
  differences_in_description: "Unterschied in der Beschreibung",
  differences_in_falatozz_availability: "Unterschied in der Verfügbarkeit bei Falatozz",
  differences_in_falatozz_price: "Unterschied im Preis bei Falatozz",
  differences_in_falatozzImage: "Unterschied im Bild bei Falatozz",
  differences_in_foodora_availability: "Unterschied in der Verfügbarkeit bei Foodora",
  differences_in_foodora_price: "Unterschied im Preis bei Foodora",
  differences_in_foodoraImage: "Unterschied im Bild bei Foodora",
  differences_in_foodpanda_availability: "Unterschied in der Verfügbarkeit bei Foodora",
  differences_in_foodpanda_price: "Unterschied im Preis bei Foodpanda",
  differences_in_image: "Unterschied im Bild",
  differences_in_included_options: "Unterschied im Rezept (standardmäßig enthaltene Zutaten)",
  differences_in_inventory: "Unterschied in der Einstellung des Inventarartikels",
  differences_in_kiosk: "Különbség a kiosk státuszban",
  differences_in_labels: "Különbség a címkékben",
  differences_in_mandatory_options: "Unterschied im Rezept (obligatorische Zutaten)",
  differences_in_manufacturer: "Unterschied im Hersteller",
  differences_in_name: "Unterschied im Namen",
  differences_in_online: "Unterschied im Webshop-Status",
  differences_in_optional_options: "Unterschied in den optionalen Optionen",
  differences_in_pos: "Unterschied in der POS-Einstellung",
  differences_in_productionlines: "Unterschied in den Produktionslinien",
  differences_in_quantitytype: "Unterschied in der Maßeinheit",
  differences_in_timing: "Unterschied im Gang",
  differences_in_top: "Unterschied im Menüstatus",
  differences_in_unitPrice: "Unterschied im Stückpreis",
  differences_in_vat: "Unterschied in der MwSt",
  differences_in_wolt_availability: "Unterschied in der Verfügbarkeit bei Wolt",
  differences_in_wolt_price: "Unterschied im Preis bei Wolt",
  differences_in_woltImage: "Unterschied im Bild bei Wolt",
  disable_edit_mode: "Tischlayout wiederherstellen",
  disconnected: "Nicht verbunden",
  discount: "Rabatt",
  discount_amount: "Fester Betrag",
  discount_percent: "Prozent",
  discount_profit: "Rabattgewinn",
  discount_types: "Rabattarten",
  discounts: "Rabatte",
  disposed_quantity: "Verfügbar",
  distance_to_big: "{0}km entfernt von der für diesen Standort festgelegten Adresse! Sind Sie wirklich jetzt an dieser Adresse? Wenn ja, sollen wir die Adresse basierend auf Ihrer aktuellen Position aktualisieren?",
  do_you_really_delete_the_customer: "Möchten Sie diesen Kunden wirklich löschen?",
  do_you_really_want_to_delete_the_menu_category: "Sind Sie sicher, dass Sie die Menü Kategorie löschen möchten?",
  do_you_really_want_to_delete_the_menu_item: "Sind Sie sicher, dass Sie den Menüpunkt löschen möchten?",
  do_you_really_want_to_print_only_the_selected_orders: "Möchten Sie wirklich nur die ausgewählte Bestellung drucken?",
  do_you_really_want_to_print_the_orders_until_timing: "Möchten Sie wirklich die Bestellungen nur bis zum <b>{0}</b> Gang drucken?",
  do_you_really_want_to_reprint_only_the_selected_orders: "Möchten Sie wirklich nur die ausgewählten Bestellungen <b><u>erneut drucken</u></b>?",
  do_you_really_want_to_reprint_the_orders_until_timing: "Möchten Sie wirklich die Bestellungen bis zum <b><u>erneut drucken</u></b> bis zum <b>{0}</b>?",
  do_you_realy_want_to_order_so_many: "Möchten Sie wirklich <strong>{0}</strong> Stück bestellen?",
  do_you_want_to_catch_incoming_calls: "Möchten Sie, dass wir die Anruferkennung für eingehende Anrufe auf diesem Telefon zur Aufzeichnung von Daten zur Hauslieferung/Abholung verwenden? Wenn ja, melden Sie sich bitte mit demselben Benutzer im Browser an!",
  documentation: "Dokumentation",
  bad: "FEHLERHAFT",
  bad_entries: "Fehlerhafte Einträge",
  good_entries: "Gute Einträge",
  barcode_filter_all: "Alle",
  barcode_filter_central_status: "Globaler DB-Status",
  barcode_filter_entry_quality: "Eintragsqualität",
  barcode_filter_synced_with_central: "Existiert in globaler Datenbank (lokal = global)",
  barcode_filter_different_from_central: "Existiert in globaler Datenbank (lokal != global)",
  barcode_sync_choose_image_title: "Bildauswahl für Synchronisierung",
  barcode_sync_choose_image_message: "Sowohl der lokale als auch der globale Eintrag enthalten ein Bild. Bitte wählen Sie, welches Bild auf beiden Seiten beibehalten werden soll.",
  barcode_sync_click_image_to_choose: "Klicken Sie auf ein Bild, um es auszuwählen.",
  barcode_sync_hint_preferred: "Hinweis: nach Punktzahl bevorzugt",
  barcode_sync_keep_local_image: "Lokales Bild behalten",
  barcode_sync_keep_global_image: "Globales Bild behalten",
  barcode_sync_local_image: "Lokales Bild",
  barcode_sync_global_image: "Globales Bild",
  bad_barcode_entries: "Fehlerhafte Barcode-Einträge",
  doesnt_exists_in_central_database: "Existiert nicht in der globalen Datenbank",
  dont_print: "Nicht drucken",
  door: "Stockwerk/Tür",
  download: "Herunterladen",
  download_barcodes: "Herunterladen",
  download_template: "Vorlage hochladen",
  draft: "Entwurf",
  drink: "Getränk",
  drink_available_quantity: "Verfügbare Mengen",
  drink_category_editor: "Getränkekategorie-Editor",
  drink_category_name: "Kategorie",
  drink_editor: "Getränke-Editor",
  drink_name: "Name",
  drink_price: "Preis",
  drink_quantity: "Menge",
  drink_quantity_name: "Name",
  drink_quantity_type: "Mengentyp",
  drinkbar: "Getränkebar",
  drinks: "Getränke",
  drop: "Fallenlassen",
  duplicate: "Duplizieren",
  duration: "Dauer",
  edit: "Bearbeiten",
  eggs: "Eier",
  email: "E-Mail",
  email_pattern: "[^@]+@[^@]+(\\.[^@]+)+",
  empty: "Leer",
  "Enable Report Scheduling": "Berichtplanung aktivieren",
  enable_edit_mode: "Tischlayout ändern",
  "enabled-features": "Aktivierte Funktionen",
  end_count: "Echt",
  enter_barion_pos_key: "Bitte geben Sie Ihren Barion-Geheimschlüssel (POSKey) ein",
  enter_category: "Kategoriename eingeben",
  enter_cost: "Kosten festlegen",
  enter_description: "Beschreibung bei Bedarf eingeben",
  enter_Drink_menuitem: "Gerichtname eingeben",
  enter_invoice_heading: "Bitte geben Sie die Überschrift der Rechnungen im HTML-Format ein!",
  enter_labels: "Wählen Sie Ihre Etiketten",
  enter_Meal_menuitem: "Getränkename eingeben",
  enter_percent: "Bitte geben Sie den MwSt-Satz in Prozent ein (z.B. 27)",
  enter_phone_number: "Telefonnummer eingeben",
  enter_price: "Preis festlegen: z.B. 500 oder 40%",
  new_price: "Neuer Preis",
  change_order_items_state: "Status von Bestellpositionen ändern",
  edit_order: "Bestellung bearbeiten",
  enter_production_line_name: "Namen für Produktionslinie eingeben ",
  enter_table_number: "Tischnummer eingeben",
  enter_table_seats: "Verfügbare Plätze eingeben",
  enter_vat_category_name: "Bitte geben Sie den Namen der MwSt-Kategorie ein",
  entities: "Entitäten",
  entity: "Entität",
  entity_type: "Entitätstyp",
  entries: "Einträge",
  entry: "Eintrag",
  entry_count: "Eintragsanzahl",
  epd: "Tischanzeige",
  events: "Ereignisse",
  except: "Außer",
  exchange_rate: "Wechselkurs",
  exists_in_central_database: "Existiert in der globalen Datenbank",
  exit_rearrange_mode: "Neu anordnen-Modus beenden",
  expiry_date: "Ablauf",
  extend_occupation: "Aktuelle Belegung verlängern",
  extensions: "Erweiterungen",
  "External HealthCheck: Successful": "Drucker scheint in Ordnung zu sein",
  extra_frame_bottom: "Inhalt unterer Rahmen",
  extra_frame_left: "Inhalt linker Rahmen",
  extra_frame_right: "Inhalt rechter Rahmen",
  extra_frame_top: "Inhalt oberer Rahmen",
  failed_to_create_production_line_not_unique: "Erstellung der Produktionslinie fehlgeschlagen! Nicht eindeutig!",
  failed_to_create_table_not_unique: "Erstellung des Tisches fehlgeschlagen. Tischnummer wird bereits verwendet!",
  failed_to_delete_discount_type_in_use: "Löschen des Rabatttyps fehlgeschlagen! Er wird bereits verwendet. Deaktivieren Sie ihn stattdessen!",
  failed_to_delete_drink_category_in_use: "Löschen der Getränkekategorie fehlgeschlagen! Sie wird bereits verwendet. Deaktivieren Sie sie stattdessen!",
  failed_to_delete_drink_in_use: "Löschen des Getränks fehlgeschlagen! Es wird bereits verwendet. Deaktivieren Sie es stattdessen!",
  failed_to_delete_label_in_use: "Löschen des Etiketts fehlgeschlagen! Es wird bereits verwendet. Deaktivieren Sie es stattdessen!",
  failed_to_delete_meal_category_in_use: "Löschen der Speisekategorie fehlgeschlagen! Sie wird bereits verwendet. Deaktivieren Sie sie stattdessen!",
  failed_to_delete_meal_in_use: "Löschen des Gerichts fehlgeschlagen! Es wird bereits verwendet. Deaktivieren Sie es stattdessen!",
  failed_to_delete_production_line_in_use: "Löschen der Produktionslinie fehlgeschlagen! Sie wird bereits verwendet. Deaktivieren Sie sie stattdessen!",
  failed_to_delete_table_in_use: "Der Tisch kann nicht gelöscht werden! Er wurde bereits verwendet! Deaktivieren Sie ihn stattdessen!",
  failed_to_delete_user: "Löschen fehlgeschlagen. <br>Fehler: {0}",
  failed_to_delete_user_anonimize: "Der Benutzer kann nicht gelöscht werden! Möchten Sie stattdessen anonymisieren? Name, E-Mail, Passwort werden gelöscht!",
  failed_to_execute_action: "Aktion fehlgeschlagen!",
  failed_to_get_restaurant_layout: "Kein Restaurantlayout definiert! Bitte laden Sie zuerst eines hoch!",
  failed_to_print_invoice: "Rechnung konnte nicht gedruckt werden!",
  failed_to_print_kitchen_slip: "Küchenbeleg konnte nicht gedruckt werden!",
  failed_to_send_order: "Bestellung fehlgeschlagen: {0}",
  feedback: "Feedback",
  feedbacks: "Rückmeldungen",
  final_stock: "Endbestand",
  finalCost: "Endkosten",
  finalPrice: "Endpreis",
  first_modify_start_date: "Ändern Sie zuerst die Startzeit",
  fiscal_receipt_already_printed: "Dieser fiskalische Beleg wurde bereits gedruckt (Belegnr.: {0})",
  fiscat_service_fee: "Servicegebühr",
  fish: "Fisch",
  fix_quantity: "Feste Menge",
  floorplans: "Grundrisse",
  food: "Essen",
  for_all: "Für alle anwenden",
  for_selected_none: "Für ausgewählte nicht anwenden",
  for_selected_order: "Für ausgewählte Bestellung anwenden",
  for_selected_tableMate: "Für ausgewählte Person anwenden",
  for_store: "Für Lager",
  format: "Format",
  free_seats: "Freie Plätze",
  from_store: "Quelllager",
  fromDate: "Von Datum",
  fromTime: "Von Zeit",
  full_inventory: "Vollständiges Inventar",
  partial_inventory: "Teilinventar",
  generate_access_token: "Zugriffstoken generieren",
  getting_location: "Bestimme deinen aktuellen Standort...",
  global_id: "Globale ID",
  global_value: "Globaler Wert",
  gluten: "Gluten",
  Grid: {
    Pager: {
      Button: {
        backButtonText: "Zurück",
        nextButtonText: "Weiter"
      },
      Description: {
        no_records: "Keine %{recordType} verfügbar",
        records_displayed: "%{firstIndex} bis %{lastIndex} von %{total} %{recordType} angezeigt"
      }
    }
  },
  gross_weight: "Bruttogewicht",
  hellopay: {
    error: {
      "1": "Unbekannter oder anderer Fehler",
      "10": "Benutzer befindet sich im Menü",
      "11": "Fehler bei der Validierung der externen Kennung",
      "12": "Fehler beim Laden der Transaktion",
      "13": "Unzureichende Berechtigungen",
      "14": "Terminal befindet sich nicht im richtigen Zustand (wird von OTP/Unipass gesteuert)",
      "2": "Zeitüberschreitung oder Unterbrechung, Karte nicht gefunden",
      "3": "Ungültige oder fehlerhafte Karte",
      "4": "Unzureichendes Guthaben auf der Karte",
      "5": "Falsche Karte eingelegt",
      "6": "Nicht umkehrbar, da es nicht die letzte Transaktion ist",
      "7": "Keine HelloPay-Karte",
      "8": "Kartenkommunikationsfehler",
      "9": "Tabletkommunikationsfehler"
    }
  },
  history: "Verlauf",
  homedelivery: "Hauslieferung",
  hospitalityUnit: "Gastgewerbeeinheit",
  hour: "Stunde",
  how_much: "Wie viel",
  id: "Id",
  if: "Bedingung",
  image: "Bild",
  included: "Entfernbare",
  included_receipe: "Zutaten, die im Produkt enthalten sind, aber bei der Bestellung entfernt oder ersetzt werden können. Zum Beispiel kann in einem Cappuccino Milch durch laktosefreie Milch ersetzt werden.",
  included_recipe: "Zutaten, die im Produkt enthalten sind, aber bei der Bestellung entfernt oder ersetzt werden können. Zum Beispiel kann in einem Cappuccino Milch durch laktosefreie Milch ersetzt werden.",
  income: "Einkommen",
  income_without_cost: "Einkommen ohne Kosten?",
  incoming_stock: "Eingehend",
  incoming_stock_entry_text_input: "Text Eingabe",
  incomingStock: "Eingehender Bestand",
  incomingStocks: "Eingehende Bestände",
  inDays: "In {0} Tagen",
  inherit: "Übernehmen",
  initial_stock: "Anfangsbestand",
  initialCost: "Anfangskosten",
  initialPrice: "Anfangspreis",
  inMonths: "In {0} Monaten",
  input_stores: "Eingabewarenhäuser",
  install_printer_server: "Installation des Druckerservers",
  installments_strategy: "Zahlungsplan",
  "Internal HealthCheck: Successful": "Drucker scheint in Ordnung zu sein",
  inventory: "Inventar",
  inventory_disposal: "Entsorgung",
  inventory_shortage: "Mangel",
  inventory_surplus: "Überschuss",
  invoice: "Rechnung",
  invoice_logo: "Rechnungslogo",
  invoice_logo_padding: "Rechnungslogo-Ausrichtung",
  choose_image: "Bild auswählen",
  use_restaurant_logo: "Restaurantlogo verwenden",
  no_image_selected: "Kein Bild ausgewählt",
  logo_padding_helper_hint: "Der Schachbrett-Hintergrund macht die weißen Seitenabstände sichtbar.",
  logo_width_ratio: "Breitenverhältnis des Logos",
  monochrome_threshold: "Monochrom-Schwellwert",
  threshold_description: "Dunklere Pixel als dieser Wert werden schwarz; hellere werden weiß.",
  invoice_count: "Ursprüngliche Menge",
  invoice_footer: "Rechnungsfußzeile",
  invoice_heading: "Rechnungsüberschrift",
  invoice_id: "Rechnungsnummer",
  invoice_not_found: "Rechnungsnummer nicht im Online-SZAMLA-System gefunden",
  invoice_printed: "Rechnung erfolgreich an den Drucker gesendet",
  inYears: "In {0} Jahren",
  is_paid: "Bezahlt",
  isInventoryItem: "Inventarartikel",
  isInventoryItem2: "Inventarartikel/Rohmaterial",
  isInventoryItem3: "Inventarartikel",
  isPos: "POS",
  isTop: "Hauptprodukt",
  item: "Artikel",
  joins: "Verbindet",
  joins_table: "Verbindet die {0}. Belegung mit {1} Personen",
  joins_table1: "Verbindet die erste Belegung mit {0} Personen",
  kiosk: "Kiosk",
  kioskOrder: "Kiosk-Bestellung",
  label: "Etikett",
  label_count: "Etikettenanzahl",
  label_printer: "Etikettendrucker",
  labels: "Etiketten",
  language: "Sprache",
  languages: "Sprachen",
  last_3_months: "Letzte 3 Monate",
  last_30_days: "Letzte 30 Tage",
  last_7_days: "Letzte 7 Tage",
  last_month: "Letzter Monat",
  last_quarter: "Letztes Quartal",
  last_status: "Letzter Status",
  last_week: "Letzte Woche",
  lastBuy: "Letzter Kauf",
  lastInventory: "Letztes Inventar",
  lastSale: "Letzte Nutzung",
  latitude: "Breitengrad",
  layout_succesfully_saved: "Tischlayout gespeichert!",
  linked_product: "Verknüpftes eigenes Produkt",
  list: "Liste",
  local_addition_tooltip: "Gilt für den lokalen Verbrauch",
  local_consumption: "Lokaler Verbrauch",
  local_product: "Verknüpftes Produkt",
  local_url: "LAN-URL",
  local_value: "Lokaler Wert",
  localConsumption: "Lokaler Verbrauch",
  lock: "Besetzen",
  lock_homedelivery: "Neue Hauslieferung",
  lock_pickup: "Neue Abholung",
  locked: "Besetzt",
  longitude: "Längengrad",
  lupin: "Lupine",
  make_bookOnline: "Gästeoccupation aktivieren",
  make_kiosk: "Ist Kiosk",
  make_non_kiosk: "Ist kein Kiosk",
  make_non_pos: "Ist kein Verkaufsort",
  make_nonBookOnline: "Gästeoccupation deaktivieren",
  make_nonVisibleOnline: "Tisch vor Gästen verbergen",
  make_pos: "Ist Verkaufsort",
  make_shareable: "Tisch teilbar machen",
  make_unshareable: "Tisch nicht teilbar machen",
  make_visibleOnline: "Tisch für Gäste sichtbar machen",
  mandatory: "Obligatorisch",
  mandatory_radio_option: "Eine Option muss aus der Kategorie bei der Bestellung ausgewählt werden",
  mandatory_receipe: "Zutaten, die das Produkt enthalten muss. Zum Beispiel, im Falle von Pizza, der Pizzaboden.",
  manual: "Manuell",
  manualOnly: "Manuell",
  manufacturer: "Hersteller",
  map: "Karte",
  mate_already_joined_table_in_this_restaurant: "{0} ist bereits Tisch Nr. {1} beigetreten!",
  maxPrice: "Höchstpreis",
  maxStock: "Höchstbestand",
  meal: "Gericht",
  meal_available_quantity: "Verfügbare Mengen",
  meal_category_editor: "Gerichtskategorie-Editor",
  meal_category_name: "Kategorie",
  meal_editor: "Gerichte-Editor",
  meal_name: "Name",
  meal_price: "Preis",
  meal_quantity: "Menge",
  meal_quantity_name: "Name",
  meal_quantity_type: "Mengentyp",
  meal_timing: "Zeitpunkt",
  meals: "Gerichte",
  menu: "Menü",
  menuitem: "Artikel",
  menuitem_ordered: "Was",
  menuitems: {
    _complex_product: "Nicht verkaufter komplexer Produkt",
    _complex_product_ingredient: "Nicht verkaufter komplexer Produktunterartikel",
    _complex_product_ingredient_option: "Nicht verkaufter komplexer Produktunterartikel und Option",
    _complex_product_option: "Nicht verkaufter komplexer Produkt und Option",
    _inventory: "Nicht verkaufter lagernder ungenutzter Bestandteil",
    _inventory_ingredient: "Nicht verkaufter lagernder Bestandteil",
    _inventory_ingredient_option: "Nicht verkaufter lagernder Bestandteil und Option",
    _inventory_option: "Nicht verkaufter lagernder Option",
    _linked_product: "Nicht verkaufter referenzierter Produkt",
    _linked_product_ingredient: "Nicht verkaufter referenzierter Produktunterartikel",
    _linked_product_ingredient_option: "Nicht verkaufter referenzierter Produktunterartikel und Option",
    _linked_product_option: "Nicht verkaufter referenzierter Produkt und Option",
    _service: "Nicht verkaufter Service",
    _service_ingredient: "Nicht verkaufter Serviceunterartikel",
    _service_ingredient_option: "Nicht verkaufter Serviceunterartikel und Option",
    _service_option: "Nicht verkaufter Serviceoption",
    sold_complex_product: "Verkauftes komplexes Produkt",
    sold_complex_product_ingredient: "Verkauftes komplexes Unterprodukt",
    sold_complex_product_ingredient_option: "Verkauftes komplexes Unterprodukt und Option",
    sold_complex_product_option: "Verkauftes komplexes Produkt und Option",
    sold_inventory: "Verkauftes lagerndes Produkt",
    sold_inventory_ingredient: "Verkauftes lagerndes Produktbestandteil",
    sold_inventory_ingredient_option: "Verkauftes lagerndes Produktbestandteil Option",
    sold_inventory_option: "Verkauftes lagerndes Produkt Option",
    sold_linked_product: "Verkauftes verknüpftes Produkt",
    sold_linked_product_ingredient: "Verkauftes referenziertes Produktbestandteil",
    sold_linked_product_ingredient_option: "Verkauftes referenziertes Produktbestandteil Option",
    sold_service: "Verkauftes Service",
    sold_service_ingredient: "Verkauftes Serviceunterprodukt",
    sold_service_ingredient_option: "Verkauftes Serviceunterprodukt und Option",
    sold_service_option: "Verkauftes Serviceoption",
    tooltip: {
      _complex_product: "Nicht direkt verkauft komplexes Produkt, das aus anderen Produkten besteht",
      _complex_product_ingredient: "Nicht direkt verkauft komplexes Produkt, das aus anderen Produkten besteht, und von einem anderen Produkt in seinem Rezept referenziert wird",
      _complex_product_ingredient_option: "Nicht direkt verkauft komplexes Produkt, das aus anderen Produkten besteht, und von einem anderen Produkt in seinem Rezept sowie als Option referenziert wird",
      _complex_product_option: "Nicht direkt verkauft komplexes Produkt, das aus anderen Produkten besteht, sowie als Option für ein anderes Produkt",
      _inventory: "Lagernder Bestandteil, der nicht von anderen Produkten verwendet/referenziert wird",
      _inventory_ingredient: "Nicht direkt verkauft lagernder Bestandteil, der von einem anderen Produkt in seinem Rezept referenziert wird",
      _inventory_ingredient_option: "Nicht direkt verkauft lagernder Bestandteil, der von einem anderen Produkt in seinem Rezept sowie als Option referenziert wird",
      _inventory_option: "Nicht direkt verkauft lagernder Bestandteil, der von einem anderen Produkt als Option referenziert wird",
      _linked_product: "Nicht direkt verkauft referenziertes (anders bepreist, spezielle Menge oder nur eine Kopie eines anderen Produkts) Produkt",
      _linked_product_ingredient: "Nicht direkt verkauft referenziertes (anders bepreist, spezielle Menge oder nur eine Kopie eines anderen Produkts) Produkt, und ist in einem anderen Produktrezept enthalten",
      _linked_product_ingredient_option: "Nicht direkt verkauft referenziertes (anders bepreist, spezielle Menge oder nur eine Kopie eines anderen Produkts) Produkt, und wird von einem anderen Produkt in seinem Rezept sowie als Option referenziert",
      _linked_product_option: "Nicht direkt verkauft referenziertes (anders bepreist, spezielle Menge oder nur eine Kopie eines anderen Produkts) Produkt, sowie als Option für ein anderes Produkt",
      _service: "Nicht verkaufter Service, der von keinem anderen Produkt als Rezept oder Option referenziert wird",
      _service_ingredient: "Nicht direkt verkaufter Service, der von einem anderen Produkt in seinem Rezept referenziert wird",
      _service_ingredient_option: "Nicht direkt verkaufter Service, der von einem anderen Produkt in seinem Rezept sowie als Option referenziert wird",
      _service_option: "Nicht direkt verkaufter Service, der von einem anderen Produkt als Option referenziert wird",
      active: "Aktives Produkt",
      available_online: "Produkt verfügbar für Online-Bestellung",
      deactivated: "Deaktiviertes Produkt",
      def_is_inventory_item: "Standard, kann aber nicht als Verpackungsoption während des Verkaufs ausgewählt werden. Das ist nicht gut. Wählen Sie eine standardmäßige verkaufsfähige Verpackung! Diese Einheit ist die Grundlage für das Bestandsmanagement. Sie kann in dieser Einheit empfangen und inventarisiert werden.",
      def_non_inventory_item: "Standard, kann aber nicht als Verpackungsoption während des Verkaufs ausgewählt werden. Das ist nicht gut. Wählen Sie eine standardmäßige verkaufsfähige Verpackung! Normale Produktmenge. Keine Inventareinheit.",
      def_on_menu_is_inventory_item: "Standard und kann als Verpackungsoption während des Verkaufs ausgewählt werden. Diese Einheit ist die Grundlage für das Bestandsmanagement. Sie kann in dieser Einheit empfangen und inventarisiert werden.",
      def_on_menu_non_inventory_item: "Standard und kann als Verpackungsoption während des Verkaufs ausgewählt werden. Normale Produktmenge. Keine Inventareinheit.",
      default_inventory_item: "Inventarverwaltetes Produkt (Rohmaterial). Erbt diese Eigenschaft von seiner Kategorie.",
      default_not_inventory_item: "Nicht-inventarverwaltetes Produkt. Erbt diese Eigenschaft von seiner Kategorie.",
      expected_profit: "Erwartete Gewinnspanne",
      free_quantity: "Während der Bestellung kann die verkaufte Menge frei geändert werden (z.B. notwendig für das Wiegen von Waren).",
      inventory_item: "Inventarverwaltetes Produkt (Rohmaterial)",
      is_inventory_item: "Kann nicht als Verpackungsoption während des Verkaufs ausgewählt werden. Diese Einheit ist die Grundlage für das Bestandsmanagement. Sie kann in dieser Einheit empfangen und inventarisiert werden.",
      no_inventory_quantity_selected: "Das Produkt ist ein lagernder Inventarartikel, aber es wurde keine Inventargröße ausgewählt.",
      non_inventory_item: "Kann nicht als Verpackungsoption während des Verkaufs ausgewählt werden. Normale Produktmenge. Keine Inventareinheit.",
      not_available_online: "Produkt derzeit nicht verfügbar für Online-Bestellung",
      not_free_quantity: "Während der Bestellung können nur vordefinierte Verpackungsoptionen (Mengen) ausgewählt werden.",
      not_inventory_item: "Nicht-inventarverwaltetes Produkt (Rohmaterial)",
      not_on_kiosk: "Nicht verfügbar im Kiosk",
      not_on_menu: "Kein Hauptprodukt, nicht direkt bestellbar, nur als Option für andere Produkte",
      not_online: "Produkt nicht sichtbar im Onlineshop",
      not_pos: "Kann nicht vor Ort von Kellner oder Verkäufer bestellt werden",
      on_kiosk: "Verfügbar im Kiosk",
      on_menu: "Hauptprodukt, direkt bestellbar",
      on_menu_is_inventory_item: "Kann als Verpackungsoption während des Verkaufs ausgewählt werden. Diese Einheit ist die Grundlage für das Bestandsmanagement. Sie kann in dieser Einheit empfangen und inventarisiert werden.",
      on_menu_non_inventory_item: "Kann als Verpackungsoption während des Verkaufs ausgewählt werden. Normale Produktmenge. Keine Inventareinheit.",
      online: "Produkt sichtbar im Onlineshop",
      pos: "Kann vor Ort von Kellner oder Verkäufer bestellt werden",
      profit_ratio: "Gewinnspanne",
      sold_complex_product: "verkauftes komplexes Produkt, das aus anderen Produkten besteht",
      sold_complex_product_ingredient: "komplexes Unterprodukt verkauft, bestehend aus anderen Produkten",
      sold_complex_product_option: "verkauftes komplexes Produkt, das aus anderen Produkten besteht, sowie als Option für ein anderes Produkt",
      sold_inventory: "Verkauftes lagerndes fertiges Produkt, d.h. das verkaufte Produkt ist auch ein inventarisiertes Rohmaterial.",
      sold_inventory_ingredient: "Verkauftes lagerndes fertiges Produkt, d.h. das verkaufte Produkt ist auch ein inventarisiertes Rohmaterial und Bestandteil eines anderen Produkts.",
      sold_inventory_ingredient_option: "Verkauftes lagerndes fertiges Produkt, d.h. das verkaufte Produkt ist auch ein inventarisiertes Rohmaterial und Bestandteil eines anderen Produkts, sowie als Option.",
      sold_inventory_option: "Verkauftes lagerndes fertiges Produkt, d.h. das verkaufte Produkt ist auch ein inventarisiertes Rohmaterial und Option eines anderen Produkts.",
      sold_linked_product: "verkauftes verknüpftes Produkt",
      sold_linked_product_ingredient: "verkauftes verknüpftes Produkt, Bestandteil",
      sold_linked_product_ingredient_option: "verkauftes referenziertes Produkt, Unterprodukt, Optionen, d.h. es verweist nur auf ein Produkt",
      sold_linked_product_option: "verkauftes referenziertes Produkt, Optionen, d.h. es verweist nur auf ein Produkt",
      sold_service: "Verkauftes Service, bei dem das Produkt nicht inventarisiert ist (kein Rohmaterial) und keine anderen Produkte enthält (leeres Rezept), wodurch es zu einem Service wird.",
      sold_service_ingredient: "Verkauftes Service-Unterprodukt, bei dem das Produkt nicht inventarisiert ist (kein Rohmaterial) und keine anderen Produkte enthält (leeres Rezept), wodurch es zu einem Service wird, aber es wird im Rezept eines anderen Produkts referenziert.",
      sold_service_ingredient_option: "verkauftes Service-Zutatenoption, d.h. das Produkt selbst ist nicht lagernd (kein Bestandteil) und enthält keine anderen Produkte (leeres Rezept), sodass es ein Service ist, und andere Produkte referenzieren es in ihrem Rezept sowie als Option",
      sold_service_option: "verkauftes Serviceoption, d.h. das Produkt selbst ist nicht lagernd (kein Bestandteil) und enthält keine anderen Produkte (leeres Rezept), sodass es ein Service ist, das von anderen Produkten als Option referenziert wird",
      suggested_price: "Vorgeschlagener Preis",
      to_many_inventory_quantity_selected: "Das Produkt hat mehrere Inventargrößen, sodass das System nicht bestimmen kann, von welcher die Inventur reduziert werden soll. Bitte wählen Sie nur eine Inventargröße aus.",
      unit_cost: "Netto-Einkaufspreis",
      unit_price: "Verkaufspreis für eine Einheit zum lokalen Verbrauch"
    }
  },
  menus: {
    administration: "Verwaltung",
    advertisements: "Werbung",
    analytics: "Analytik",
    bankTerminal: "Bankterminal",
    bankTerminals: "Bankterminals",
    bar: "Bar",
    barcodes: "Barcodes",
    bi: "Business Intelligence",
    cashRegisters: "Kassen",
    check_subscriptions: "Abonnements überprüfen",
    comments: "Kommentare",
    customers: "Kunden",
    currencies: "Währungen",
    daily_closing: "Täglicher Abschluss",
    discounts: "Rabatte",
    drinks: "Getränke",
    falatozz: "Falatozz",
    falatozz_administration: "Falatozz-Administration",
    foodora_administration: "Foodora-Administration",
    foodpanda: "FoodPanda",
    guestScreen: "Gästeanzeige",
    incomingStocks: "Eingehende Bestände",
    inventory: "Inventar",
    inventoryScrapping: "Inventarentsorgung",
    kiosks: "Kioske",
    labels: "Etiketten",
    pricetags: "Preisschilder",
    manage_reports: "Berichte verwalten",
    mautic: "CRM",
    meals: "Gerichte",
    menuitems: "Produkte",
    monitoring: "Überwachung",
    opening_hours: "Öffnungszeiten",
    orders: "Bestellungen",
    orders_quick_action: "Bestellstatus festlegen",
    paymentMethods: "Zahlungsmethoden",
    plans: "Pläne",
    pointOfSales: "Verkaufsstellen",
    printers: "Drucker",
    productionLines: "Produktionslinien",
    products: "Produkte",
    profile: "Mein Profil",
    rbac: "Zugriffsrollen",
    reports: "Berichte",
    restaurants: "Restaurants",
    scales: "Waagen",
    send_reseller_fees: "Händlergebühren senden",
    send_reseller_fees_to_me: "Händlergebühren nur an mich senden",
    serving: "Servieren",
    servings: "Portionen",
    shoppingList: "Einkaufsliste",
    stockList: "Bestandsverwaltung",
    stockManagement: "Bestandsverwaltung",
    stockMovements: "Bestandsbewegungen",
    stockReport: "Bestandsstatistik",
    stores: "Lagerhäuser",
    superAdminMenu: "Super-Admin",
    suppliers: "Lieferanten",
    support: "Unterstützung",
    tableBooking: "Tischreservierungen",
    tableOverview: "Tischübersicht",
    tables: "Tische",
    todaytraffic: "Täglicher Verkehr",
    traffic: "Verkehr",
    updateSettings: "Aktualisierungen",
    users: "Benutzer",
    VATCategories: "MwSt-Kategorien",
    voipphone: "VOIP-Telefon",
    waiterScreen: "Kellnerbildschirm",
    wolt: "Wolt",
    wolt_administration: "Wolt-Administration",
    guidelines_whats_new: "Richtlinien & Neuigkeiten",
    video_guides: "Videoanleitung",
    chat_with_support: "Chatten Sie mit dem Support"
  },
  milk: "Milch",
  minimum_price: "Der Endpreis darf nicht niedriger sein als der Basispreis, selbst wenn die Standardoptionen zum Zeitpunkt der Bestellung deaktiviert sind. Zum Beispiel, bei Pizzen, selbst wenn ein Belag entfernt wird, sollte die Pizza nicht günstiger werden.",
  minimumStock: "Mindestmenge, wann wir typischerweise nachbestellen",
  minPrice: "Mindestpreis",
  minStock: "Mindestbestand",
  minute: "Minute",
  minutes: "Minuten",
  modified_by: "Geändert",
  mollusks: "Schalentiere",
  month: "Monat",
  monthsAgo: "{0} Monate her",
  more_addresses: "Weitere Adressen",
  more_than_a_day: "> 1 Tag",
  kitchen_total_time: "Gesamt",
  move_back: "Nach hinten verschieben",
  move_backward: "Rückwärts bewegen",
  move_forward: "Vorwärts bewegen",
  move_top: "Nach oben verschieben",
  moved_quantity: "Übertragene Menge",
  multiple_inventory_quantity_selected: "Möchten Sie wirklich mehrere einzelne Inventargrößen festlegen!",
  multiple_physical_printers_try_to_server_the_virtual_server: "Mehrere physische Drucker sind für den virtuellen Drucker {0} konfiguriert! Der '{1}' und der '{2}'!",
  multiplicator: "Multiplikator",
  mustard: "Senf",
  myOrders: "Meine Bestellung",
  mode: "Modus",
  templates: "Vorlagen",
  select: "Auswählen",
  save_as_template: "Als Vorlage speichern",
  template_name: "Vorlagenname",
  template_name_required: "Der Vorlagenname ist erforderlich.",
  fill_out_guide: "Ausfüllhilfe",
  inventory_excel_menu_item_id: "Produkt-ID",
  inventory_excel_menu_item_global_id: "Globale Produkt-ID",
  inventory_excel_inventory_quantity: "Inventurmenge",
  inventory_excel_count: "Menge",
  inventory_excel_guide_no_unit: "Wenn keine Einheit angegeben ist, wird der Wert als Menge × Menge × Mengeneinheit interpretiert. Beispiel: Menge=1000, Einheit=g, Wert=2 => 2 × 1000g = 2000g.",
  inventory_excel_guide_editable_column: "Nur die Spalte \"{0}\" ist bearbeitbar.",
  inventory_excel_guide_units: "Sie können Werte wie 10l, 10dl, 10g, 10kg, 10Stk eingeben. Das System rechnet automatisch um.",
  invalid_inventory_count: "Verwende eine Zahl oder eine Zahl mit der passenden Einheit für diesen Artikel.",
  inventory_excel_guide_interpretation: "Die Menge wird in der Inventureinheit dieser Zeile interpretiert: {0} + {1}.",
  inventory_excel_guide_empty_skipped: "Wenn die Menge leer ist, wird die Zeile beim Import übersprungen.",
  no_traffic_items_message: "Die folgenden Artikel haben keine aktuelle Aktivität und werden aus diesem Inventar ausgeschlossen: {0}{1}",
  exclude_no_traffic_items: "Artikel ausschließen",
  keep_no_traffic_items: "Artikel behalten",
  no_entries_can_be_added_for_selected_store: "Für den ausgewählten Store können keine Einträge hinzugefügt werden.",
  search: "Suchen",
  guidelines_whats_new_intro: "Rollenbasierte Updates und betriebliche Richtlinien für Ihr Konto.",
  video_guides_intro: "Kurze Videos, die die häufigsten Aufgaben zeigen.",
  video_guides_search_placeholder: "Titel, Zusammenfassung oder Tags suchen",
  video_guides_empty: "Keine Videoanleitung entspricht Ihrer Suche.",
  video_guides_coming_soon: "Video folgt in Kürze",
  video_guides_play: "Video abspielen",
  video_guides_large_player: "Großer Player (HD)",
  video_guides_open_youtube: "Auf YouTube öffnen",
  video_guides_close: "Schließen",
  video_guides_recorded_with: "Playwright-Skript",
  video_guides_show_script: "Skript anzeigen",
  video_guides_hide_script: "Skript ausblenden",
  video_guides_script_missing: "Das Skript ist noch nicht exportiert. Ausführen: npm run video:export",
  voice_order_open: "Per Sprache bestellen",
  voice_order_title: "Sprachbestellung",
  voice_order_close: "Schließen",
  voice_order_start: "Mikrofon einschalten",
  voice_order_stop: "Mikrofon ausschalten",
  voice_order_connecting: "Verbinde...",
  voice_order_stopped: "Das Mikrofon ist aus",
  voice_order_listening: "Ich höre zu, sagen Sie, was die Gäste möchten",
  voice_order_thinking: "Moment...",
  voice_order_speaking: "Spreche...",
  voice_order_empty: "Die Liste ist leer.",
  voice_order_comment: "Kommentar",
  voice_order_remove: "Entfernen",
  voice_order_clear: "Leeren",
  voice_order_add: "Zur Tischbestellung hinzufügen",
  voice_order_not_configured: "Die Sprachbestellung ist auf dem Server nicht eingerichtet.",
  voice_order_session_failed: "Der Sprachassistent konnte nicht gestartet werden. Versuchen Sie es gleich noch einmal.",
  voice_order_mic: "Das Mikrofon ist nicht verfügbar. Erlauben Sie der App den Zugriff auf das Mikrofon.",
  voice_order_connection: "Die Sprachverbindung wurde unterbrochen.",
  voice_order_no_table: "Wählen Sie zuerst einen Tisch und fügen Sie die Liste dann seiner Bestellung hinzu.",
  voice_order_incomplete: "Nicht alles wurde bestellt. Der Rest bleibt auf der Liste.",
  voice_action_confirm: "Bestätigen",
  voice_order_lock_failed: "Der Tisch konnte nicht geöffnet werden. Öffnen Sie ihn zuerst auf dem Bildschirm.",
  voice_order_print_failed: "Die Artikel wurden hinzugefügt, aber nicht abgeschickt und gedruckt. Verwenden Sie Bestellen und drucken.",
  voice_action_dismiss: "Verwerfen",
  voice_action_done: "Erledigt",
  voice_action_failed: "Es hat nicht geklappt",
  voice_move_confirm: "%{from} auf %{to} verschieben?",
  voice_join_confirm: "%{from} auf %{to} verschieben und mit den dortigen Gästen zusammenführen?",
  voice_new_confirm: "%{from} als eigene Gruppe an den gemeinsamen Tisch %{to} setzen?",
  voice_extend_confirm: "%{from} um den gemeinsamen Tisch %{to} erweitern?",
  voice_add_table_confirm: "%{to} zu %{from} hinzufügen?",
  voice_remove_orders_confirm: "Bestellung löschen: %{items}?",
  voice_unlock_confirm: "%{table} schließen?",
  voice_unlock_confirm_cancel: "%{table} schließen und die %{count} unbezahlte(n) Bestellung(en) stornieren?",
  guidelines_whats_new_search_label: "Suche",
  guidelines_whats_new_search_placeholder: "Titel, Zusammenfassung, Details oder Tags suchen",
  guidelines_whats_new_filter_type_all: "Alle Typen",
  guidelines_whats_new_filter_freshness_all: "Alle Updates",
  guidelines_whats_new_date_range_label: "Datumsbereich",
  guidelines_whats_new_filter_module_all: "Alle Tags",
  guidelines_whats_new_filter_module_placeholder: "Tags auswählen",
  guidelines_whats_new_date_range_all_time: "Alle Zeit",
  guidelines_whats_new_date_range_1day: "Seit 1 Tag geändert",
  guidelines_whats_new_date_range_1week: "Seit 1 Woche geändert",
  guidelines_whats_new_date_range_1month: "Seit 1 Monat geändert",
  guidelines_whats_new_date_range_2months: "Seit 2 Monaten geändert",
  guidelines_whats_new_date_range_3months: "Seit 3 Monaten geändert",
  guidelines_whats_new_date_range_1year: "Seit 1 Jahr geändert",
  guidelines_whats_new_structure_title: "Nach Tags gruppiert",
  guidelines_whats_new_journey_orders: "Bestellungen und Service",
  guidelines_whats_new_journey_kitchen_delivery: "Küche und Lieferung",
  guidelines_whats_new_journey_inventory_admin: "Lager und Administration",
  guidelines_whats_new_journey_administration: "Administration",
  guidelines_whats_new_journey_insights: "Berichte und Analysen",
  guidelines_whats_new_module_sales: "Verkauf",
  guidelines_whats_new_module_kitchen: "Kuche",
  guidelines_whats_new_module_stockmanagement: "Lagerverwaltung",
  guidelines_whats_new_module_reports: "Berichte",
  guidelines_whats_new_module_administration: "Administration",
  guidelines_whats_new_module_integrations: "Integrationen",
  guidelines_whats_new_type_guideline: "Geändert",
  guidelines_whats_new_type_whats_new: "Neu",
  guidelines_whats_new_freshness_new: "Neu",
  guidelines_whats_new_freshness_changed: "Geändert",
  guidelines_whats_new_freshness_stable: "Stabil",
  guidelines_whats_new_created_at: "Erstellt",
  guidelines_whats_new_modified_at: "Geändert",
  guidelines_whats_new_reset_filters: "Zurücksetzen",
  guidelines_whats_new_results: "Ergebnisse",
  guidelines_whats_new_empty: "Keine Updates für Ihre aktuelle Rolle verfügbar.",
  name: "Name",
  not_logged_in_yet: "Noch nicht eingeloggt",
  superadmin: {
    add_user: "Benutzer hinzufügen",
    edit_user: "Benutzer bearbeiten",
    activate_user: "Benutzer aktivieren",
    deactivate_user: "Benutzer deaktivieren",
    add_role: "Rolle hinzufügen",
    delete: "Löschen",
    sync_to_mautic: "Mit Mautic synchronisieren",
    user: "Benutzer",
    online: "Online",
    active: "Aktiv",
    role: "Rolle",
    entity_type: "Entitätstyp",
    entity: "Entität",
    filter_by_name: "Nach Namen filtern...",
    filter_by_entity: "Nach Entität filtern...",
    all: "Alle",
    offline: "Offline",
    deactivated: "Deaktiviert",
    default: "Standard",
    admin: "Admin",
    printer_server: "Druckserver",
    user_replication: "Benutzerreplikation",
    tester: "Tester",
    waiter: "Kellner",
    finance: "Finanzen",
    inventory: "Inventar",
    courier: "Kurier",
    restaurant: "Restaurant",
    store: "Lager",
    none: "Keine",
    loading: "Laden...",
    no_users_found: "Keine Benutzer gefunden",
    yes: "Ja",
    no: "Nein",
    show: "Anzeigen",
    entries: "Einträge",
    showing: "Anzeigen",
    to: "bis",
    of: "von",
    previous: "Vorherige",
    next: "Nächste",
    user_editor: "Benutzereditor",
    add_user_title: "Benutzer hinzufügen",
    edit_user_title: "Benutzer bearbeiten",
    name: "Name",
    surname: "Nachname",
    email: "E-Mail",
    password: "Passwort",
    gitlab_secure_token: "GitLab Sicherer Token",
    close: "Schließen",
    save: "Speichern",
    role_editor: "Rolleneditor",
    users: "Benutzer",
    entities: "Entitäten",
    confirmation: "Bestätigung",
    delete_user_confirm: "Sind Sie sicher, dass Sie den Benutzer {0} löschen möchten?"
  },
  name_of_customer: "Namen des Gastes festlegen",
  net_price: "Nettopreis",
  net_unit_price: "Nettoeinheitspreis",
  netto_income: "Nettoeinkommen",
  new: "neu",
  new_in_central_database: "Verfügbar aus der globalen Datenbank",
  new_independent_occupation: "Neue Belegung",
  new_lock: "+ Besetzen",
  new_occupation: "Als neue Belegung",
  new_order: "Neue Bestellung",
  new_position: "Es wurden keine GPS-Koordinaten für diese Adresse festgelegt. Möchten Sie sie auf Ihren aktuellen Standort setzen?",
  new_sale: "Neuer Verkauf",
  next: "Weiter",
  nextInventory: "Nächste geplante Inventur",
  no: "Nein",
  "No connection with the guest display": "Keine Verbindung zur Gästeanzeige",
  "No tip": "Kein Trinkgeld",
  no_bluetooth_adapter: "Bluetooth-Schnittstelle ist nicht verfügbar!",
  no_bluetooth_cashiers: "Bitte verbinden oder koppeln Sie eine Bluetooth-Kassiermaschine!",
  no_inventory_quantity: "Es wurde keine Menge für die Inventarverwaltung ausgewählt!",
  no_inventory_quantity_selected: "Inventarartikel, aber keine Inventargröße ausgewählt!",
  no_matches_found: "Keine Übereinstimmung gefunden",
  no_permission_to_perform_this_action: "Sie haben keine Berechtigung, um diese Operation auszuführen.",
  no_restaurants_found: "Keine Restaurants gefunden",
  no_serial_cashiers: "Bitte verbinden Sie eine Kassiermaschine mit USB-Seriell-Kabel!",
  non_printer_configured: "Kein Drucker konfiguriert",
  not_allowed_order_is_being_paid: "Aktion nicht erlaubt bei einer Bestellung, die gerade bezahlt wird!",
  not_allowed_order_paid: "Aktion nicht erlaubt bei einer bezahlten Bestellung!",
  not_defined: "???",
  not_empty_pattern: "\\w+",
  not_selected: "Nicht ausgewählt",
  not_used_ingredient: "Nicht verwendeter Bestandteil",
  ntak: {
    _default_ntak_main_category: "Hauptkategorie",
    _default_ntak_sub_category: "Unterkategorie",
    categories: "NTAK",
    cert: "Zertifikat (CER)",
    cert_request: "Zertifikatsanforderung (CSR)",
    cert_request_download: "Zertifikatsanforderung herunterladen",
    cert_request_generate: "Neue Zertifikatsanforderung generieren",
    cert_upload: "Zertifikat hochladen",
    default_ntak_main_category: "NTAK Hauptkategorie",
    default_ntak_sub_category: "NTAK Unterkategorie",
    key: "Privater Schlüssel (KEY)",
    key_upload: "Privaten Schlüssel hochladen",
    main_categories: [{ "id": 5, "name": "Essen", "shortName": "Essen", "sub_categories": [{ "id": 1, "name": "Frühstück" }, { "id": 2, "name": "Sandwich" }, { "id": 3, "name": "Vorspeise" }, { "id": 4, "name": "Suppe" }, { "id": 5, "name": "Hauptgericht" }, { "id": 6, "name": "Beilage" }, { "id": 7, "name": "Eingelegtes/Salat", "shortName": "Eingelegtes/Salat" }, { "id": 8, "name": "Dessert" }, { "id": 9, "name": "Snack" }, { "id": 30, "name": "Hauptgericht mit Beilage" }, { "id": 31, "name": "Essen Paket" }, { "id": 10, "name": "Sonstiges" }] }, { "id": 1, "name": "Hausgemachte alkoholfreie Getränke", "shortName": "Haus. Getränk.", "sub_categories": [{ "id": 11, "name": "Limonade/Sirup/frisch gepresster Saft", "shortName": "Lem/Syr/Fresh" }, { "id": 12, "name": "Alkoholfreier Cocktail", "shortName": "Alkoholfreier Cocktail" }, { "id": 13, "name": "Tee/heißer Schokolade" }, { "id": 14, "name": "Kaffee" }, { "id": 32, "name": "Getränkepaket" }] }, { "id": 2, "name": "Nicht hausgemachte alkoholfreie Getränke", "shortName": "Nicht-h. Getränk.", "sub_categories": [{ "id": 15, "name": "Wasser" }, { "id": 16, "name": "Kohlensäurehaltige Limonade" }, { "id": 17, "name": "Nicht kohlensäurehaltige Limonade" }, { "id": 33, "name": "Nicht kohlensäurehaltige Limonade" }, { "id": 32, "name": "Getränkepaket" }] }, { "id": 3, "name": "Alkoholische Getränke", "shortName": "Alk. Getränk.", "sub_categories": [{ "id": 18, "name": "Cocktail" }, { "id": 19, "name": "Likör" }, { "id": 20, "name": "Spirituose" }, { "id": 21, "name": "Bier" }, { "id": 22, "name": "Wein" }, { "id": 23, "name": "Sekt" }, { "id": 32, "name": "Getränkepaket" }] }, { "id": 4, "name": "Sonstiges", "shortName": "Sonstiges", "sub_categories": [{ "id": 10, "name": "Sonstiges" }, { "id": 26, "name": "Liefergebühr" }, { "id": 27, "name": "Umweltfreundliche Verpackung", "shortName": "Öko. Pack." }, { "id": 28, "name": "Plastikverpackung", "shortName": "Plas. Pack." }, { "id": 29, "name": "Rabatt" }, { "id": 34, "name": "Nicht-Catering" }] }],
    mainCategoryNotSet: "Die NTAK-Hauptkategorie ist für kein Produkt festgelegt! Sie kann auf Kategorieebene festgelegt werden (sie wird vererbt) oder auf Produktebene.",
    ntak: "NTAK",
    ntak_id: "NTAK-ID",
    save_ntak_id: "NTAK-ID speichern",
    status: "NTAK-Status",
    status_error: "NTAK-Fehler",
    subCategoryNotSet: "Die NTAK-Unterkategorie ist für kein Produkt festgelegt! Sie kann auf Kategorieebene festgelegt werden (sie wird vererbt) oder auf Produktebene.",
    taxid: "Steuer-ID",
    test: "Verbindung testen"
  },
  number_of_persons: "Anzahl der Personen",
  number_of_seats: "Verfügbare Plätze",
  nuts: "Nüsse",
  occupy: "Besetzen",
  ok: "Ok",
  oldest_order: "Neueste Bestellung: {0}",
  on_day: "Am Wochentag",
  online: "Webshop",
  online_szamla_feature: "Das Modul für die Online-Rechnung ist derzeit in Ihrem Abonnement nicht aktiviert. Das Modul kann MwSt.-Rechnungen, die im Online-Rechnungssystem empfangen wurden, herunterladen und automatisch/semi-automatisch nach Bedarf erfassen.",
  onsite: "Lokaler Verbrauch",
  open: "Öffnen",
  open_day: "Tag öffnen",
  opened: "Offen",
  opening_time: "Öffnungszeit",
  option: "Option",
  optional: "Optionen",
  optional_radio_option: "Maximal eine Option kann aus der Kategorie bei der Bestellung ausgewählt werden",
  optional_receipe: "Zusätzliche Optionen, die das Produkt entweder verbessern oder eine Standardzutat bei der Bestellung ersetzen können.",
  optional_recipe: "Zusätzliche Optionen, die das Produkt entweder verbessern oder eine Standardzutat bei der Bestellung ersetzen können.",
  order_cannot_be_deleted_while_mate_is_paying: "Bestellungen einer Person, die gerade bezahlt, können nicht gelöscht werden!<br/>Entfernen Sie zuerst den Zahlungsstatus der Person!",
  order_cannot_be_deleted_while_order_was_already_selected_for_payment_one: "Bestellungen, die einmal zur Zahlung ausgewählt wurden, können nur mit Administratorrechten gelöscht werden!",
  order_fee: "Systemnutzungsgebühr",
  order_no: "Bestellnr.",
  order_number: "Bestellnummer: {0}",
  order_sequence_number: "Bestellnummer",
  order_summary: "Bestellübersicht",
  ordered_by: "Bestellt von",
  ordering_allowed: "Rechnung widerrufen, Bestellung wieder erlaubt!",
  orders: "Bestellungen",
  orders_tab: "Bestellübersicht",
  organizer: "Organisator: {0}",
  original_quantity: "Ursprüngliche Menge",
  other: "Sonstiges",
  outgoing_stock: "Bestandsbewegungen",
  output_stores: "Ausgabewarenhäuser",
  package: "Paket",
  package_charge: "Paketgebühr",
  paid: "Bezahlt",
  paid_by: "Bezahlt von",
  paid_order_cannot_be_deleted: "Bezahlte Bestellungen können nicht gelöscht werden!",
  parent_category: "Elternkategorie",
  pay: "Zahlen",
  pay_himself: "Zahlt selbst",
  payer: "Zahler",
  paying: "Zahlen",
  payment: "Zahlung",
  payment_due_in: "Zahlung fällig in {0} Tag(en)!",
  payment_method: "Zahlungsmethode",
  payment_methods: "Zahlungsmethoden",
  payment_received_by: "Zahlung erhalten von",
  payment_successful: "Zahlung erfolgreich",
  payment_was_due_in: "Zahlung überfällig seit {0} Tag(en)!",
  payments: "Zahlungen",
  paynance: {
    error: {
      "Transaction aborted": "Transaktion abgebrochen",
      "Transaction canceled by user": "Transaktion manuell vom Benutzer abgebrochen",
      "Transaction timed out": "Transaktion aufgrund von Zeitüberschreitung abgebrochen"
    }
  },
  pays: "Zahlt",
  peanuts: "Erdnüsse",
  pending: "Ausstehend",
  per_item: "Pro Artikel",
  percent_name: "Prozent",
  person: "Person",
  person_count: "Personenzahl",
  persons: "Personen",
  phone_order_fee: "Systemnutzungsgebühr für telefonische Bestellungen",
  phonenumber: "Telefon",
  pickup: "Abholung",
  pickupyourorder: "Ihre Bestellung ist fertig",
  picture: "Bild",
  planned_closing_time: "Geplante Schließzeit",
  "Please pick a tip to proceed to payment!": "Bitte wählen Sie ein Trinkgeld, um zur Zahlung fortzufahren!",
  please_choose_mate_wanting_to_pay: "Wer möchte bezahlen?",
  please_choose_mate_who_paid: "Wer hat bezahlt?",
  please_click_on_a_time_slot_first: "Wählen Sie zuerst den Beginn der Buchung (klicken Sie auf ein Zeitfenster)!",
  please_select_a_restaurant: "Bitte wählen Sie ein Restaurant",
  point_of_sale: "POS",
  pointin: "Punkte einlösen",
  pointout: "Punkte sammeln",
  pos_producing_rules: "Status nach dem Drucken für den Verkaufsort",
  postcode: "Postleitzahl",
  postcode_pattern: "^\\d\\d\\d\\d$",
  preorder_possible: "Vorbestellung",
  price: "Preis",
  price_estimation: "Vorgeschlagener Preis",
  price_goal: "Zielpreis",
  pricePerCostRatio: "Einheitspreis / Kostenverhältnis",
  print: "Drucken",
  print_invoice: "Rechnung drucken",
  print_qrcode: "QR-Code drucken",
  print_receipt: "Quittung drucken",
  printer: "Drucker",
  printer_actions: "Druckaktionen",
  printer_errors: {
    "cover-open": "Deckel offen",
    error: "Verbindungsfehler",
    "out-of-paper": "Kein Papier mehr"
  },
  printer_server: "Druckserver",
  printer_server_name: "Name des Druckservers",
  printers: "Drucker",
  printInvoice: "Rechnung drucken",
  printTableSlip: "Tisch-QR-Code drucken",
  printVATInvoice: "MwSt-Rechnung drucken",
  privacy_policy: "Datenschutzrichtlinie",
  privacy_policy_link: "https://eatwithme.online/privacy-policy/",
  producing_rules: "Status nach dem Drucken",
  product: "Produkt",
  product_modified_save_it: "Produkt geändert!",
  product_receipe_modified_recalculate_it: "Rezept geändert. Möchten Sie die Inventur für die Vergangenheit neu berechnen",
  product_search: "Produktsuche",
  product_serving: "Typ",
  productAnalitics: "Produktanalytik",
  production_line: "Produktionslinie",
  production_line_editor: "Produktionslinie",
  production_line_is_active: "Produktionslinie ist aktiv",
  production_line_length: "Warteschlange",
  production_line_name: "Name",
  production_line_title: "{0} Produktionslinie",
  production_line_waiting: "Abhängige Produktionslinie",
  production_lines: "Produktionslinien",
  profit_margin: "Gewinnspanne",
  profitandloss: {
    avgActualPrice: "Durchschnittspreis",
    avgCost: "Durchschnittskosten",
    avgDiscount: "Durchschnittsrabatt",
    avgPrice: "Durchschnittlicher Listenpreis",
    closing_stock: "Schlussbestand",
    consumption: "Verkaufte Menge",
    cost: "Kosten",
    count: "Verkäufe",
    income: "Einkommen",
    maxCost: "Höchstkosten",
    maxPrice: "Höchstpreis",
    minCost: "Mindestkosten",
    minPrice: "Mindestpreis",
    open_stock: "Eröffnungsbestand",
    profit: "Gewinn",
    profitp: "Gewinn (%)",
    purchase: "Einkauf",
    scrapping: "Entsorgung",
    shortage: "Überschuss/Mangel",
    stock_change: "Bestandsänderung"
  },
  proportional_addition_tooltip: "Proportionale Addition. Die tatsächliche Addition ist das Produkt der ausgewählten Menge des Basiselements und der Menge der Addition.",
  provide_address: "Bitte geben Sie Ihre Adresse an",
  provide_city: "Bitte geben Sie Ihre Stadt an",
  provide_company: "Bitte geben Sie den Namen Ihres Restaurants und/oder Firmennamen an",
  provide_country: "Bitte geben Sie Ihr Land an",
  provide_phonenumber: "Bitte geben Sie Ihre Telefonnummer an",
  purchase_price: "Netto-Einkaufspreis",
  qr_code: "QR-Code",
  quantity: "Menge",
  quantity_must_be_unique: "Die verfügbaren Mengen müssen eindeutig sein!",
  quantity_type: "Mengentyp",
  quantity_types: "Serviertypen",
  rateus: "Senden Sie uns Ihr Feedback!",
  rbac: "Zugriffsrollen",
  ready_for_delivery: "Serviere es",
  rearrange_fields: "Felder neu anordnen",
  reauthenticate: "Neu authentifizieren",
  reboot_printerserver: "Druckserver neu starten",
  recalculateConsumption: "Bestand neu berechnen",
  recalculateConsumptionAll: "Alle Bestände neu berechnen",
  receipe: "Rezept",
  receipt: "Quittung",
  receiptNumber: "Quittungsnummer",
  receipts: "Quittungen",
  references: "Referenzen",
  refillStock: "Zielmenge, auf die wir typischerweise nachbestellen",
  refresh: "Aktualisieren",
  refresh_my_data: "Meine Daten aktualisieren",
  refresh_position: "Aktualisieren",
  rejection_reason: "Ablehnungsgrund",
  reload_console: "Konsole neu laden",
  refresh_kiosks: "Kioske aktualisieren",
  repay_invoice_dialog: "Möchten Sie die Zahlungsdetails ändern?",
  replace: "Ersetzen",
  reprint: "Drucken",
  reprint_receipt: "Möchten Sie die Quittung wirklich erneut drucken?",
  resend: "Erneut versuchen",
  reset_to_defaults: "Auf Standard zurücksetzen",
  resource: {
    administration: {
      advertisements: {
        description: "Anzeigeverwaltung",
        name: "Werbung"
      },
      bankterminals: {
        description: "Bankkartenterminalverwaltung",
        name: "Bankkartenterminals"
      },
      cashregisters: {
        description: "Kassenverwaltung",
        name: "Kassen"
      },
      description: "Systemverwaltung",
      discounts: {
        description: "Rabattverwaltung",
        name: "Rabatte"
      },
      falatozz: {
        description: "Falatozz-Integration",
        name: "Falatozz"
      },
      foodpanda: {
        description: "Foodpanda-Integration",
        name: "Foodpanda"
      },
      labels: {
        description: "Etikettenverwaltung",
        name: "Etiketten"
      },
      name: "Verwaltung",
      printers: {
        description: "Druckerverwaltung",
        name: "Drucker"
      },
      productionlines: {
        description: "Verwaltung der Produktionslinien",
        name: "Produktionslinien"
      },
      products: {
        description: "Produktverwaltung",
        fullaccess: {
          description: "Vollzugriff auf die Produktadministration",
          name: "Vollzugriff"
        },
        limitedaccess: {
          description: "Eingeschränkter Produktzugriff",
          name: "Eingeschränkter Zugriff"
        },
        name: "Produkte"
      },
      rbac: {
        description: "Rollenbasierte Zugriffskontrolle",
        name: "Zugriffsrollen"
      },
      restaurants: {
        description: "Restaurant-Einstellungen",
        name: "Restaurants"
      },
      scales: {
        description: "Waagenverwaltung",
        name: "Waagen"
      },
      servings: {
        description: "Portionsverwaltung",
        name: "Portionen"
      },
      tables: {
        description: "Tischverwaltung",
        name: "Tische"
      },
      vatcategories: {
        description: "MwSt.-Kategorieverwaltung",
        name: "MwSt.-Kategorien"
      },
      wolt: {
        description: "Wolt-Integration",
        name: "Wolt"
      }
    },
    bar: {
      description: "Barverwaltung",
      name: "Bar"
    },
    courierapp: {
      description: "Zugriff auf die Kurieranwendung",
      name: "Kurieranwendung",
      registerpayment: {
        description: "Zahlungsregistrierung in der Kurieranwendung",
        name: "Zahlungsregistrierung"
      },
      selfassign: {
        description: "Selbstzuweisung von Bestellungen an den Kurier",
        name: "Selbstzuweisung"
      },
      view: {
        name: "Öffnen"
      }
    },
    guestscreen: {
      description: "Verwaltung der Gästeanzeige",
      name: "Gästeanzeige"
    },
    kiosk: {
      description: "Kiosksystem",
      name: "Kiosk"
    },
    kitchen: {
      description: "Küchenanzeigesystem (KDS)",
      name: "KDS"
    },
    newsletter: {
      description: "Verwaltung des Newsletters",
      name: "Newsletter"
    },
    ntak: {
      description: "NTAK-System",
      name: "NTAK"
    },
    reports: {
      bi: {
        customers: {
          description: "Kundenanalytik",
          name: "Kundenanalytik"
        },
        delivery: {
          description: "Lieferanalytik",
          name: "Lieferanalytik"
        },
        description: "Berichte zur Geschäftsanalyse",
        financial: {
          description: "Umsatzanalytik",
          name: "Umsatz"
        },
        financial_day: {
          description: "Tägliche Umsatzanalytik",
          name: "Täglicher Umsatz"
        },
        name: "BI-Berichte",
        profit: {
          description: "Gewinnanalytik",
          name: "Gewinnanalytik"
        },
        rating: {
          description: "Bewertungsanalytik",
          name: "Bewertungsanalytik"
        }
      },
      dailyclosing: {
        description: "Berichte über den täglichen Abschluss",
        name: "Täglicher Abschluss"
      },
      description: "Berichte und Analytik",
      menuitems: {
        description: "Produktberichte",
        name: "Produkte"
      },
      name: "Berichte",
      prebookedorders: {
        description: "Berichte über vorgebuchte Bestellungen",
        name: "Vorgebuchte Bestellungen"
      },
      tableoccupations: {
        description: "Tischbelegungen und Bestellungen",
        name: "Bestellungen",
        revert: {
          description: "Wiedereröffnung/Stornierung geschlossener Bestellungen",
          name: "Wiedereröffnen"
        },
        view: {
          name: "Öffnen"
        }
      },
      todaytraffic: {
        description: "Tägliche Verkehrsdaten",
        name: "Verkehr von heute"
      },
      traffic: {
        description: "Verkehrsberichte",
        name: "Verkehr"
      }
    },
    sales: {
      always_allow_delete: {
        description: "Bestelllöschung immer erlauben",
        name: "Bestelllöschung"
      },
      dailyreport: {
        description: "Zugriff auf den täglichen Abschlussbericht",
        fullreport: {
          description: "Vollständiger täglicher Abschlussbericht",
          name: "Vollständiger Bericht"
        },
        limited: {
          description: "Eingeschränkter täglicher Abschlussbericht",
          name: "Eingeschränkt"
        },
        name: "Täglicher Abschlussbericht"
      },
      homedelivery: {
        assigntocourier: {
          description: "Hauslieferbestellungen einem Kurier zuweisen",
          name: "Dem Kurier zuweisen"
        },
        closeorders: {
          description: "Hauslieferbestellungen schließen",
          name: "Bestellungen schließen"
        },
        name: "Hauslieferung"
      },
      name: "Verkäufe",
      pickup: {
        closeorders: {
          description: "Abholbestellungen schließen",
          name: "Bestellungen schließen"
        },
        description: "Verwaltung von Abholbestellungen",
        name: "Abholung"
      },
      pointofsale: {
        name: "Verkaufsstelle",
        view: {
          name: "Anzeigen"
        }
      },
      printinvoice: {
        description: "Berechtigung zum Drucken von Rechnungen",
        name: "Rechnungsdruck"
      },
      registerpayment: {
        description: "Berechtigung zur Zahlungsregistrierung",
        name: "Zahlungsregistrierung"
      },
      revert: {
        description: "Stornierung von bezahlten/geschlossenen Bestellungen",
        name: "Stornierung"
      },
      settings: {
        description: "Verwaltung der Verkaufseinstellungen",
        name: "Verkaufseinstellungen"
      },
      tablesoverview: {
        description: "Tischübersicht",
        modify: {
          name: "Tischlayout ändern"
        },
        name: "Tischlayout",
        view: {
          name: "Anzeigen"
        }
      }
    },
    serving: {
      description: "Servierbereich",
      name: "Servieren"
    },
    stockmanagement: {
      barcodes: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Barcodeverwaltung",
        modify: {
          name: "Ändern"
        },
        name: "Barcodeverwaltung",
        view: {
          name: "Anzeigen"
        }
      },
      description: "Inventarverwaltungssystem",
      incomingstocks: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Verwaltung des eingehenden Bestands",
        modify: {
          name: "Ändern"
        },
        name: "Eingehende Bestände",
        view: {
          name: "Anzeigen"
        }
      },
      inventories: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Inventarverwaltung",
        modify: {
          name: "Ändern"
        },
        name: "Inventare",
        view: {
          name: "Anzeigen"
        }
      },
      inventorytemplates: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Verwaltung der Inventarvorlagen",
        modify: {
          name: "Ändern"
        },
        name: "Inventarvorlagen",
        view: {
          name: "Anzeigen"
        }
      },
      inventoryscrapping: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Verwaltung der Inventarentsorgung",
        modify: {
          name: "Ändern"
        },
        name: "Inventarentsorgung",
        view: {
          name: "Anzeigen"
        }
      },
      name: "Bestandsverwaltung",
      pandl: {
        description: "Gewinn- und Verlustanalytik",
        name: "Gewinn- und Verlustanalytik"
      },
      shoppinglist: {
        description: "Verwaltung der Einkaufsliste",
        name: "Einkaufsliste"
      },
      stocklist: {
        description: "Verwaltung der Bestandsliste",
        name: "Bestandsliste"
      },
      stockmovements: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Verwaltung der Bestandsbewegungen",
        modify: {
          name: "Ändern"
        },
        name: "Bestandsbewegungen",
        view: {
          name: "Anzeigen"
        }
      },
      stockstatistics: {
        description: "Bestandsstatistische Berichte",
        name: "Bestandsstatistiken"
      },
      stores: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Verwaltung der Lagerhäuser",
        modify: {
          name: "Ändern"
        },
        name: "Lagerhäuser",
        view: {
          name: "Anzeigen"
        }
      },
      suppliers: {
        add: {
          name: "Hinzufügen"
        },
        delete: {
          name: "Löschen"
        },
        description: "Verwaltung der Lieferanten",
        modify: {
          name: "Ändern"
        },
        name: "Lieferanten",
        view: {
          name: "Anzeigen"
        }
      }
    },
    tablebooking: {
      book: {
        name: "Neue Buchung"
      },
      description: "Tischbuchungssystem",
      name: "Tischbuchung",
      settings: {
        name: "Einstellungen"
      },
      "view:": {
        name: "Öffnen"
      }
    },
    waiter: {
      description: "Zugriff auf den Kellnerbildschirm",
      name: "Kellnerbildschirm"
    }
  },
  restart_needed: "(Neu)Starten Sie den Drucker",
  restart_printer: "Bitte starten Sie den folgenden Drucker neu: {0}",
  restart_printerserver: "Drucker neu verbinden",
  network_speeds: "Netzwerkgeschwindigkeiten",
  client: "Client",
  client_server: "Client/Server",
  sse: "SSE",
  download: "Herunterladen",
  upload: "Hochladen",
  ip_address: "IP",
  restaurant: "Restaurant",
  restaurant_editor: "Restaurant",
  restaurant_properties_includedoptions: "Rezept - standardmäßig enthaltene Zutaten",
  restaurant_properties_mandatoryoptions: "Rezept - obligatorische Zutaten",
  restaurant_properties_optionaloptions: "Rezept - optionale Optionen",
  restaurant_settings: {
    default_language: "Standardsprache"
  },
  revert: "Lass uns zurücksetzen",
  revert_payment: "Möchten Sie die Zahlung wirklich zurücksetzen?",
  revert_table_mate_payment: "Zahlungen ebenfalls zurücksetzen",
  revert_table_occupation: "Möchten Sie wirklich zurücksetzen?",
  revert_table_occupation2: "Was möchten Sie mit dieser Bestellung tun?",
  revert_table_occupation_multi_payment: "Möchten Sie wirklich zurücksetzen? Es gab mehrere Zahler, die Zahlung kann im Reiter Zahlungen zurückgesetzt werden!",
  role: "Rolle",
  role_names: {
    admin: "Administrator",
    cook: "Koch",
    courier: "Kurier",
    finance: "Finanzen",
    printerserver: "DruckerServer",
    store: "Inventarverwalter",
    tester: "Tester",
    waiter: "Kellner"
  },
  roles: "Rollen",
  room: "Raum",
  room_editor: "Raum",
  room_tables: "{0} Tische",
  room_tables_seats: "{0} Tische mit {1} Plätzen",
  rotate_left: "Nach links drehen (45°)",
  rotate_right: "Nach rechts drehen (45°)",
  rounding: "Rundung",
  sale: "Verkauf",
  save: "Speichern",
  save_and_close: "Speichern & Schließen",
  save_and_new: "Speichern+Kopieren",
  save_and_open: "Speichern & Testen",
  save_and_unlock: "Zahlen und freigeben",
  save_layout: "Tischlayout speichern",
  save_my_details_for_later_use: "Ich stimme zu, dass meine persönlichen Daten von {0} und dem cloudbasierten Restaurantverwaltungssystem EatWithMe gespeichert und verwaltet werden.",
  save_update_address: "Speichern und Adresse aktualisieren",
  saved_my_details_for_later_use: "Ich habe zugestimmt, dass meine persönlichen Daten von {0} und dem cloudbasierten Restaurantverwaltungssystem EatWithMe gespeichert und verwaltet werden.",
  scan_to_join_table: "!LF!ESC|cA!ESC|4CTisch {0}!LF!LF!ESC|4C!ESC|cAScan und bestellen!LF!ESC|cAund verwalten Sie Ihren Verbrauch online!",
  scan_to_pay_table: "Scannen Sie mit Ihrem Telefon\r\n um den Verbrauch am Tisch Nr. {0} zu sehen.\r\nund die Rechnung online zu begleichen!",
  scanit: "Ist das Ihre Rechnung? Scannen Sie sie!",
  scope: "Bereich",
  scrapping: "Entsorgung",
  search_pattern: "Suchmuster",
  seat: "Sitz",
  seat_types: {
    normal_chair: "Normaler Stuhl",
    wooden_chair: "Holzstuhl"
  },
  seats: "Sitze",
  secret_key: "Geheimer Schlüssel",
  select_a_category: "Wählen Sie eine Kategorie aus",
  select_a_product: "Wählen Sie ein Produkt aus",
  select_a_quantity_type: "Wählen Sie einen Mengentyp aus",
  select_a_store: "Wählen Sie ein Lager aus",
  select_a_supplier: "Wählen Sie einen Lieferanten aus",
  select_a_vat_category: "Wählen Sie eine MwSt-Kategorie aus",
  select_store: "Lager auswählen",
  selling_price: "Bruttoverkaufspreis",
  seqnr: "Sequenznummer",
  server_url: "WAN-URL",
  service: "Service",
  service_fee: "Servicegebühr",
  service_fee_net: "Netto-Servicegebühr",
  service_fee_vat: "Getrennte Servicegebühren",
  serving: "Servieren",
  serving_type: "Kiszerelés",
  sesame: "Sesam",
  settings: "Einstellungen",
  shareable: "Teilbar",
  short_name: "Kurzname",
  shortage: "Mangel",
  show_deleted: "Gelöschte Artikel anzeigen",
  sitting_at_table: "Sitzt am Tisch Nr. {0}",
  skin_picker: "Themenauswahl",
  skins: [{ "id": "default", "name": "Standard" }, { "id": "fancy", "name": "Fancy" }, { "id": "flat", "name": "Flat" }, { "id": "night", "name": "Nacht" }, { "id": "old", "name": "Alter Stil" }],
  something_strange_happened_resync: "Etwas Unerwartetes ist passiert! Synchronisieren...",
  sort_abc: "Sortieren",
  source_and_target_store_should_be_different: "Quelle und Ziellager sollten unterschiedlich sein",
  soybeans: "Sojabohnen",
  split_invoice: "Rechnung aufteilen",
  stable_versions: "Stabile Versionen",
  start_count: "Erwartet",
  status: "Status",
  stock: "Bestand",
  stock_movement: "Bestandsbewegung",
  stockAnalitics: "Bestandsanalytik",
  store: "Lager",
  stores: "Lagerhäuser",
  storno: "Storno",
  stornoreason: "Stornierungsgrund",
  stornoreason_0: "Sonstiges",
  stornoreason_1: "Stornierung durch den Kunden",
  stornoreason_2: "Falsche Eingabe",
  stornoreason_3: "Falsche Eingabe der Zahlungsmethode",
  stornoreason_4: "Produkt nicht auf Lager",
  stornoreason_5: "Falsche Dokumentenausstellung",
  stornoreason_6: "Fehlerhafte Nutzung der Zahlungsmethode",
  stornoreason_7: "Falsche Kundendaten/falsche Eingabe",
  stornoreason_8: "Testkauf",
  submit_and_accept_and_print_and_pay_new_orders: "Zahlung",
  submit_and_accept_and_print_new_orders: "Neue Bestellungen drucken",
  submit_and_accept_new_orders: "Neue Bestellungen einreichen und akzeptieren",
  submit_new_orders: "Neue Bestellungen einreichen",
  subscription: "Abonnement",
  sulfites: "Sulfite",
  supplier: "Lieferant",
  supplier_code: "Lieferantencode",
  suppliers: "Lieferanten",
  surplus: "Überschuss",
  suspend_ordering: "Bestellungen aussetzen",
  syncronize_barcodes: "Synchronisieren",
  table: "Tisch",
  table_editor: "Tisch",
  table_extentions_placeholder: "+tisch_nummer=gesamtanzahl_sitze z.B. +4=8,+4+5=12",
  table_free_seats: "Verfügbare Plätze",
  table_is_active: "Tisch ist aktiv",
  table_is_shareable: "Tisch ist teilbar",
  table_number: "Tischnummer: {0}",
  table_number_label: "Tischnummer",
  table_occupation_number: "Belegungsnr. {0}",
  table_occupations: "Tische",
  table_ready_for_delivery: "!ESC|bC!ESC|4CTisch Nr. {0}!LF!ESC|bC!ESC|4CBestellnr. {1}!LF!ESC|bC!ESC|4C{2}!LF!ESC|bC!ESC|4CLiefern Sie es!",
  table_types: {
    circle_four_seats: "Runder Tisch für vier Personen",
    person: "Person",
    persons: "Personen",
    pool_table: "Billardtisch",
    rectangle_four_seats: "Tisch für vier Personen",
    rectangle_six_seats: "Tisch für sechs Personen",
    rectangle_two_seats: "Tisch für zwei Personen",
    rounded_four_seats: "Runder Tisch für vier Personen",
    rounded_six_seats: "Runder Tisch für sechs Personen"
  },
  tableOccupations: "Tischbelegungen",
  tables: "Tische",
  tablesoverview: {
    tooltip: {
      printed: "Erfolgreich gedruckt.",
      printfailed: "Nicht erfolgreicher Druckversuch. Bitte erneut drucken.",
      printing: "Druckvorgang läuft",
      unprinted: "Die Bestellung wurde noch nicht gedruckt."
    }
  },
  takeaway: "Mitnahme",
  takeaway_addition_tooltip: "Gilt für Mitnahme oder Hauslieferung",
  takeaway_consumption: "Mitnahmeverbrauch",
  takeawayConsumption: "Mitnahmeverbrauch",
  tare_weight: "Taragewicht",
  target_table_same_and_source: "Zieltisch ist derselbe wie die Quelle!",
  tax_number: "Steuernummer",
  tax_number_pattern: "(^$)|(^\\d\\d\\d\\d\\d\\d\\d\\d-\\d-\\d\\d$)",
  team_number: "Team: {0}",
  terminal: "Terminal",
  test: "Test",
  test_mode: "Testmodus",
  test_scale: "Waagentest",
  test_system: "Testsystem",
  test_versions: "Testversionen",
  teya: {
    error: {
      CANCELLED: "Kartenzahlung abgebrochen",
      CANCELLING: "Kartenzahlung wird abgebrochen",
      FAILED: "Kartenzahlung fehlgeschlagen",
      NEW: "Kartenzahlung fehlgeschlagen. Keine Antwort vom Terminal!",
      unknown: "Kartenzahlung fehlgeschlagen"
    }
  },
  thanks_for_buying: "Danke für Ihren Einkauf",
  "The address.address field is required.": "Das Adressfeld ist erforderlich.",
  "The address.address must be at least 2 characters.": "Die Adresse muss mindestens 2 Zeichen enthalten.",
  "The address.city field is required.": "Das Stadtfeld ist erforderlich.",
  "The address.city must be at least 2 characters.": "Der Stadtname muss mindestens 2 Zeichen enthalten.",
  "The address.post code field is required.": "Das Feld für die Postleitzahl ist erforderlich.",
  "The device communications channel could not be opened, check the device and retry.": "Der Drucker ist nicht eingeschaltet oder falsch konfiguriert.",
  "The name field is required.": "Das Namensfeld ist erforderlich.",
  the_table_is_not_occupied: "Dieser Tisch ist frei!",
  there_already_exists_a_table_with_this_number: "Sie haben bereits einen Tisch mit dieser Nummer platziert!",
  layout_must_remain_wider_than_tall: "Das Layout muss breiter als hoch bleiben.",
  there_is_a_loop_in_the_additions: "Es gibt eine Referenzschleife zwischen den Menüelementen!",
  this_month: "Dieser Monat",
  this_quarter: "Dieses Quartal",
  this_week: "Diese Woche",
  time: "Zeit",
  timetable: "Öffnungszeiten",
  timing: "Zeitpunkt",
  timing_appetizer: "Vorspeise",
  timing_asap: "So schnell wie möglich",
  timing_desert: "Dessert",
  timing_inherit: "Übernehmen",
  timing_last: "Am Ende",
  timing_maincourse: "Hauptgericht",
  timing_null: "",
  tip: "Trinkgeld",
  tip_amount_seems_excesive: "Betrag scheint übertrieben! Fortfahren?",
  to_store: "Ziel-Lager",
  to_whom: "An wen",
  toDate: "Bis Datum",
  today: "Heute",
  token: "Token",
  tomorrow: "Morgen",
  too_many_bluetooth_cashiers: "Es kann nur eine Bluetooth-Kassiermaschine gleichzeitig gekoppelt werden!",
  tooltip: {
    address: "Bitte geben Sie die vollständige Adresse an, z.B. 'Árpád köz 2.'. Wenn das System die Adresse nicht finden kann, akzeptiert das System jede Adresse mit einem '/' am Anfang, z.B. '/Am Eingang des Bahnhofs'",
    comment: "Setzen Sie einen Kommentar nur für diese Bestellung!",
    couriers: "Mögliche Kuriere (Benutzer mit Kurierberechtigungen). Diese Berechtigung kann registrierten Benutzern in der Verwaltung zugewiesen werden.",
    delivery_time: "Geplante Lieferzeit",
    header_accepted_order: "Bestellung bestätigt! Sie können alle ausstehenden oder ausgewählten Bestellungen durch Doppelklick erneut bestätigen!",
    header_filter_accepted_order: "Bestätigte Bestellungen filtern",
    header_filter_new_incoming_order: "Neue Bestellungen filtern",
    header_filter_order_assigned: "Bestellungen, die dem Kurier zugewiesen sind",
    header_filter_order_delivered: "Gelieferte Bestellungen filtern",
    header_filter_order_in_production: "Bestellung in Vorbereitung filtern",
    header_filter_order_ready: "Fertige Bestellungen filtern",
    header_filter_order_under_delivering: "Bestellungen in Zustellung filtern",
    header_new_incoming_order: "Neue Bestellung wartet auf Bestätigung!",
    header_order_delivered: "Bestellung geliefert! Sie können diesen Status für alle oder ausgewählte Bestellungen durch Doppelklick festlegen!",
    header_order_in_production: "Bestellung in Vorbereitung! Sie können diesen Status für alle oder ausgewählte Bestellungen durch Doppelklick festlegen!",
    header_order_ready: "Bestellung fertig! Sie können diesen Status für alle oder ausgewählte Bestellungen durch Doppelklick festlegen!",
    header_order_under_delivering: "Bestellung in Zustellung! Sie können diesen Status für alle oder ausgewählte Bestellungen durch Doppelklick festlegen!",
    header_print_invoice: "Doppelklick, um die Rechnungen für alle oder ausgewählte Bestellungen zu drucken!",
    header_print_receipt: "Doppelklick, um alle noch ungedruckten Bestellungen oder ausgewählte Bestellungen zu drucken!",
    print_all_labels: "Doppelklick, um alle Etiketten zu drucken!",
    header_unlock: "Doppelklick, um alle entsperrbaren (gelieferte und bezahlte) Bestellungen zu entsperren oder zu sperren!",
    link_courier: "Doppelklick, um die ausgewählten Bestellungen diesem Kurier zuzuweisen!",
    paid: "Rechnung bezahlt.",
    pickup_time: "Geplante Abholzeit",
    print_invoice: "Doppelklick, um die Rechnung zu drucken!",
    print_receipt: "Doppelklick, um die Bestellung zu drucken!",
    printed: "Erfolgreiches Drucken! Doppelklick, um eine Kopie zu drucken.",
    printfailed: "Nicht erfolgreicher Druckversuch. Doppelklick, um einen neuen Druckversuch zu starten.",
    printing: "Druckvorgang läuft",
    qrcode: "Doppelklick, um das Block des Kuriers zu drucken.",
    register_payment: "Doppelklick, um Zahlungsdetails zu registrieren.",
    reprint_receipt: "Doppelklick, um die Bestellung erneut zu drucken!",
    set_accepted_order: "Bestellung bestätigt! Sie können die Bestellung erneut bestätigen, indem Sie doppelt klicken!",
    set_new_incoming_order: "Neue Bestellung wartet auf Bestätigung!",
    set_order_delivered: "Bestellung geliefert! Sie können diesen Status durch Doppelklick festlegen!",
    set_order_in_production: "Bestellung in Vorbereitung! Sie können diesen Status durch Doppelklick festlegen!",
    set_order_ready: "Bestellung fertig! Sie können diesen Status durch Doppelklick festlegen!",
    set_order_under_delivering: "Bestellung in Zustellung! Sie können diesen Status durch Doppelklick festlegen!",
    unlink_courier: "Doppelklick, um die Bestellung vom Kurier zu entfernen!",
    unlock: "Doppelklick, um die Bestellung zu entsperren oder zu sperren!",
    unprinted: "Die Bestellung wurde noch nicht gedruckt. Doppelklick, um zu drucken.",
    user_comment: "Setzen Sie einen dauerhaften Kommentar für Ihren Kunden. Dieser Kommentar wird auch bei zukünftigen Bestellungen angezeigt!"
  },
  tooltip_label_count: "Anzahl der Etiketten, die für dieses Produkt gedruckt werden sollen, falls ein Etikettendrucker verwendet wird",
  tooltip_notprinted: "Noch nicht gedruckt!",
  tooltip_partprinted: "Druckfehler! Neuer Druckversuch wird durchgeführt!",
  tooltip_printed: "Gedruckt",
  tooltip_printfailed: "Druckfehler!",
  tooltip_printing: "Druckvorgang läuft!",
  top_category: "Obere Kategorie",
  total: "Gesamt",
  total_incoming_stock_entries: "<span>{0}</span> <span class='browser-only'> Einträge insgesamt</span>",
  total_stock_cost: "Warenbeschaffungskosten",
  total_stock_value: "Warenverkaufswert",
  total_value_difference: "Gesamter Wertunterschied",
  town: "Stadt",
  traffic: "Verkehr",
  type: "Typ",
  typical_rejection_reasons: "Typische Gründe",
  ui: {
    addResource: "Ressource hinzufügen",
    addRole: "Rolle hinzufügen",
    cancel: "Abbrechen",
    close: "Schließen",
    delete: "Löschen",
    deleteResources: "Ressourcen löschen",
    description: "Beschreibung",
    descriptionLabel: "Beschreibung:",
    newResource: "Neue Ressource",
    permission: "Berechtigung",
    permissionName: "Berechtigungsname:",
    resource: "Ressource",
    resourceName: "Ressourcenname:",
    role: "Rolle",
    roleName: "Rollenname:",
    save: "Speichern"
  },
  unassigned_orders: "Nicht zugewiesene Bestellungen",
  uncategorized_items: "Produkte ohne festgelegte Kategorie",
  unit_of_consumption: "Verkaufs-/Nutzungseinheit",
  unit_price: "Einheitspreis",
  unit_price_estimation: "Vorgeschlagener Einheitspreis",
  unknown_person_pays: "Person {0}. zahlt",
  unlock: "Freigeben",
  unoccupy: "Freigeben",
  until_when_delete_the_traffic: "Bis wann möchten Sie den Verkehr löschen (Format: JJJJ-MM-TT)",
  updateBookingNotSuccessful: "Speichern der Kundendaten war nicht erfolgreich",
  upload: "Hochladen",
  upload_barcodes: "Hochladen",
  upload_successful: "Hochladen erfolgreich",
  user: "Benutzer",
  user_comment: "Weitere Gästeinformationen",
  user_missing: "Kein Benutzer ist für die angegebene E-Mail-Adresse registriert",
  users: "Benutzer",
  value_difference: "Wertunterschied",
  vat: "MwSt",
  vat_categories: "MwSt-Kategorien",
  vat_category: "MwSt-Kategorie",
  vat_category_editor: "MwSt-Kategorie",
  vat_category_name: "MwSt-Kategoriename",
  vat_invoice: "MwSt-Rechnung",
  view: "Anzeigen",
  visible_online: "Für Gäste sichtbar",
  "voipphone-Registration failed:Authentication Error": "Registrierung fehlgeschlagen:Authentifizierungsfehler",
  "voipphone-undefined": "Offline",
  waiterOrder: "Kellnerbestellung",
  webshop: "Webshop",
  webshop_order_fee: "Systemnutzungsgebühr für Webshop-Bestellungen",
  webshopOrder: "Webshop-Bestellung",
  week: "Woche",
  when: "Wann",
  withdraw: "Abheben",
  without_allergen: "ohne {0} Allergen",
  wolt: {
    delete_category: "Produktkategorie von Wolt löschen",
    delete_category_items: "Von Wolt Produkte löschen, die nur für diese Kategorie dort existieren",
    delete_menu_item: "Produkt von Wolt löschen",
    delete_menu_items: "Produkte von Wolt löschen",
    delete_selected_elements: "Ausgewählte Produkte von Wolt löschen",
    elements_in_sync: "Anzahl der synchronisierten Produkte",
    elements_in_to_delete: "Anzahl der zusätzlichen Produkte auf Wolt",
    elements_in_to_upload: "Anzahl der fehlenden Produkte auf Wolt",
    elements_in_unsync: "Anzahl der nicht synchronisierten Produkte",
    reload: "Von Wolt aktualisieren",
    resync_selected_elements: "Ausgewählte Produkte erneut mit Wolt synchronisieren",
    sync_category_items: "Produkte, die sowohl in EatWithMe als auch in Wolt existieren, synchronisieren",
    sync_menu_item: "Produkt mit Wolt synchronisieren",
    upload_category: "Produktkategorie von Wolt löschen",
    upload_category_items: "Fehlende Produkte auf Wolt hochladen",
    upload_menu_item: "Produkt zu Wolt hochladen",
    upload_selected_elements: "Ausgewählte Produkte zu Wolt hochladen"
  },
  yearsAgo: "{0} Jahre her",
  yes: "Ja",
  yesterday: "Gestern",
  "You do not have subscription for this operation": "Sie haben kein Abonnement für diese Operation",
  you_are_not_authorized_to_access_this_feature: "Basierend auf Ihrem Abonnement dürfen Sie nicht auf diese Funktion zugreifen.",
  you_are_not_authorized_to_access_this_restaurant_with_an_app: "Basierend auf Ihrem Abonnement dürfen Sie nicht auf diese Einheit zugreifen.",
  you_cannot_order_so_many: "Sie können nicht so viele <strong>{0}</strong> Stück auf einmal bestellen!",
  you_need_admin_right_for_this_action: "Sie benötigen Administratorrechte, um diese Aktion auszuführen!",
  CLEAR_PRODUCT: 'Produkt löschen',
  ADD_MISSING_PRODUCT: 'Fehlendes Produkt hinzufügen',
  CLEAR_QUANTITY_TYPE: 'Mengentyp löschen',
  CLEAR_VAT_CATEGORY: 'MwSt-Kategorie löschen',
  CLEAR_STORE: 'Lager löschen',
  VALIDATION_SUCCESS: 'Alle Validierungen erfolgreich',
  SEARCH_PRODUCTS: 'Tippen Sie, um Produkte zu suchen...',
  SEARCH_QUANTITY_TYPES: 'Tippen Sie, um Mengentypen zu suchen...',
  SEARCH_VAT_CATEGORIES: 'Tippen Sie, um MwSt-Kategorien zu suchen...',
  SEARCH_STORES: 'Tippen Sie, um Lagerhäuser zu suchen...',
  enter_invoice_id: 'Bitte geben Sie die Rechnungsnummer ein',
  enter_delivery_note_id: 'Bitte geben Sie die Lieferbeleg-ID ein',
  cannotSave: 'Speichern ist aufgrund von Fehlern nicht möglich',
  select_vat_category: 'Wählen Sie eine MwSt-Kategorie aus',
  query_invoice_data: 'Rechnungsdaten aus dem NAV ONLINE-SZAMLA-System abfragen',
  failed_to_query_invoice_data: 'Fehler beim Abfragen der Rechnungsdaten aus dem NAV ONLINE-SZAMLA-System',
  open_in_new_tab: 'In neuem Tab öffnen',
  upload_menu: 'Menü hochladen',
  connect_choiceqr: "Mit ChoiceQR verbinden",
  choiceqr_connect_token_info: "Im ChoiceQR-Fenster müssen Sie den folgenden Token (Code) verwenden, um die Verbindung zu autorisieren. Kopieren Sie ihn zuerst und öffnen Sie dann die ChoiceQR-Seite.",
  choiceqr_copy: "In die Zwischenablage kopieren",
  choiceqr_copied: "Kopiert",
  choiceqr_open_connect: "ChoiceQR öffnen",
  choiceqr_connected: "ChoiceQR ist jetzt verbunden.",
  choiceqr_waiting: "Warten auf den Abschluss der Verbindung...",
  choiceqr_missing_domain_or_client: "Bitte zuerst Domain und clientId in den Einstellungen ausfüllen.",
  connect_wolt_instance: "Wolt-Konto verbinden",
  connect_button: "Mit Wolt verbinden",
  code_received: "Autorisierungscode erhalten!",
  error: "Fehler: {0}",
  sync_superset: "Superset-Synchronisierung",
  invalid_barcode_gross_tare_weight: "Das Bruttogewicht muss größer als das Tara-Gewicht sein!",
  storno_payment_method: "Rückzahlungszahlungsart",
  refund_payment_method: "Rückzahlungszahlungsart",
  card: "Karte",
  cash: "Bargeld",
  cash_return_calculation: "Wechselgeldberechnung",
  cash_return_calculation_help: "Wenn aktiviert, sind Bargeldstueckelungen nur sichtbar, wenn ein Bargeldzahlungsbetrag groesser als 0 ist und das Eingabefeld fuer Bargeld den Fokus hat. Durch Klick auf die Stueckelungen kann der erhaltene Bargeldbetrag gesetzt werden. Das System berechnet daraus das Wechselgeld.",
  storno_quantity: "Storno-Menge",
  return_and_refund: "Rückgabe und Rückerstattung",
  refundreason_1: "Defektes Produkt",
  refundreason_2: "Kundenrücktritt vom Kauf",
  refundreason_3: "Anderer Grund",
  VATInvoice: "MwSt-Rechnung",
  preorder: "Vorbestellung",
  automation: {
    id: "ID",
    name: "Name",
    menu_item: "Menüpunkt",
    menu_category: "Menükategorie",
    optional_category_options: "Optionale Kategorieoptionen",
    optionType: "Optionstyp",
    proportional: "Proportional",
    context: "Kontext"
  },
  drive: {
    check_for_wolt_delivery: "Wolt-Lieferung überprüfen",
    wolt_drive_delivery_time: "Geplanter Wolt-Lieferzeitpunkt",
    wolt_drive_price: "Wolt-Lieferpreis",
    wolt_drive_no_info: "Keine Informationen zu den Wolt-Lieferbedingungen",
    wolt_drive_reason: "Wolt-Lieferbedingungen sind nicht erfüllt, weil",
    "Dropoff location is outside the delivery area": "Abgabeort liegt außerhalb des Liefergebiets",
    "Dropoff location is outside of the delivery area": "Abgabeort liegt außerhalb des Liefergebiets",
    delivery_with_wolt_courier: "Lieferung mit Wolt-Kurier",
    wolt_courier: "Wolt-Kurier",
    "Request made outside delivery hours": "Anfrage außerhalb der Lieferzeiten",
    "Delivery area is closed": "Liefergebiet ist geschlossen",
    "Delivery area will be closed at the requested delivery time": "Liefergebiet ist zum gewünschten Lieferzeitpunkt geschlossen",
    "already_received_cannot_reassign": "Die Bestellung wurde bereits vom Wolt-Kurier bestätigt, sie kann nicht einem neuen Kurier zugewiesen werden",
    "already_received_cannot_delete": "Die Bestellung wurde bereits vom Wolt-Kurier bestätigt, die Kurierbestellung kann nicht gelöscht werden",
    "Value error, Invalid phone number: (1) The string supplied did not seem to be a phone number": "Wertfehler, ungültige Telefonnummer: Die angegebene Zeichenkette scheint keine Telefonnummer zu sein",
    "Value error, 'name' can not be empty": "Wertfehler, 'Name' darf nicht leer sein",
    "Order is not in a rejectable state. Please contact support to cancel it": "Bestellung ist nicht stornierbar. Bitte wenden Sie sich an den Support, um sie zu stornieren",
    already_assigned_to_wolt_courier: "Sie haben diesem Auftrag bereits einen Wolt-Kurier zugewiesen",
    earliest_delivery_time: "Früheste Lieferzeit ist %{time} statt %{originaltime} %{fromNow}",
  },
  contact_email: "Kontakt-E-Mail",
  website_url: "Webseiten-URL",
  login_in_progress: "Anmeldung läuft...",
  deleted_by: "Gelöscht von",
  not_bound_to_table: "Nicht an einen Tisch gebunden",
  no_epd: "Kein Tischdisplay ausgewählt",
  pairing_code: "Kopplungscode",
  pair: "Koppeln",
  new_purchase_price: "Neuer Einkaufspreis.",
  last_approved_purchase_price: "Letzter genehmigter Einkaufspreis.",
  approve_it_with_double_click: "Genehmigen Sie den neuen Einkaufspreis mit einem Doppelklick!",
  costChangeFilter: "Zeigt nur Artikel an, deren Einkaufspreis sich um den angegebenen Prozentsatz oder mehr geändert hat",
  stockDangerFilter: "Zeigt nur Artikel an, deren Bestand gefährdet ist",
  stockBuyFilter: "Zeigt nur Artikel an, die nachbestellt werden müssen",
  filters: "Filter",
  approved_cost: "Genehmigter Einkaufspreis",
  _approved_cost: "Genehmigter Einkaufspreis",
  cost_change: "Änderung",
  _cost_change: "Änderung",
  new_average_cost: "Neuer durchschnittlicher Einkaufspreis",
  _new_average_cost: "Neuer durchschnittlicher Einkaufspreis",
  cost_change_warning: "Kostenüberschreitung",
  costChangeThreshold: "Schwellenwert für Kostenänderung",
  approve: "Genehmigen",
  the_following_products_were_not_found: "Die folgenden Produkte wurden nicht gefunden",
  promotional_price: "Aktionspreis",
  enter_promotional_price: "Aktionspreis",
  enter_promotion_name: "Name der Aktion",
  enter_promotional_start_date: "Geben Sie das Startdatum der Aktion ein",
  enter_promotional_end_date: "Geben Sie das Enddatum der Aktion ein",
  promotion_name: "Name der Aktion",
  promotional_start_date: "Aktionsbeginn",
  promotional_end_date: "Aktionsende",
  promotion_price: "Aktionspreis",
  promotion: "Aktion",
  promotions: "Aktionen",
  differences_in_promotionName: "Unterschiede im Namen der Aktion",
  differences_in_promotionPrice: "Unterschiede im Aktionspreis",
  differences_in_promotionStart: "Unterschiede im Startdatum der Aktion",
  differences_in_promotionEnd: "Unterschiede im Enddatum der Aktion",
  old: "Alter Stil",
  permanent_delete: "Dauerhaft löschen",
  menu_item_availability: "Menüpunkt-Verfügbarkeit",
  availability_explanation: "Als nicht verfügbar markierte Artikel werden automatisch auf allen Bestellplattformen ausgeblendet (Kiosk, Wolt, Foodpanda usw.).",
  unavailable_items: "Derzeit nicht verfügbar",
  all_items_available: "Alle Produkte verfügbar",
  make_unavailable_matching: "Übereinstimmende deaktivieren",
  make_available_matching: "Übereinstimmende aktivieren",
  make_all_available: "Alle aktivieren",
  search_to_add_remove: "Suchen...",
  availability_enabled_hint: "Der Artikel ist wieder verfügbar. Er kann wieder auf Wolt/Foodora-, Kiosk- und Webshop-Plattformen erscheinen.",
  availability_disabled_hint: "Der Artikel ist jetzt nicht verfügbar. Er kann auf Wolt/Foodora-, Kiosk- und Webshop-Plattformen ausgeblendet werden.",
  tabledisplay_link_button: "Tischdisplay verknüpfen",
  tabledisplay_scan_unavailable: "QR-Scanner ist auf diesem Gerät nicht verfügbar.",
  tabledisplay_scan_invalid: "Der gescannte QR-Code enthält keine gültige Display-ID.",
  tabledisplay_scan_failed: "Scannen des Display-QR-Codes fehlgeschlagen.",
  tabledisplay_link_success: "Tischdisplay verknüpft: {0} -> {1} (Vorlage: {2}).",
  tabledisplay_link_failed: "ESL-Produkt für das gescannte Display konnte nicht erstellt und verknüpft werden.",
  unavailable: "nicht verfügbar",
  available: "verfügbar",
};
export default admin_local_de;
